// src/services/api.ts
import axios from 'axios';
import { Stage, Funnel, VerificarContratoEtapaResponse, AtualizarConfiguracaoContratoData, RelatorioConfiguracaoContrato } from '../types/funnels';
import { OpportunityStatus, CreateOpportunityData, OpportunityFilters, OpportunityDetail } from '../types/opportunity';
import { Arquivo, Anotacao, CreateAnotacaoData, UpdateAnotacaoData } from '../types/notes';
import { Anexo, CreateAnexoData, UpdateAnexoData } from '../types/anexos';
import { Contato, CreateContatoData, ContatoFilters } from '../types/contato';
import { Fornecedor, CreateFornecedorData, FornecedorFilters } from '../types/fornecedor';
import { Municipio, MunicipioFilters } from '../types/municipio';
import { Origem, CreateOrigemData, UpdateOrigemData } from '../types/origens';
import { IOpportunityStatus, CreateOpportunityStatusData, UpdateOpportunityStatusData } from '../types/opportunityStatus';
import { IUnidadeMedida, CreateUnidadeMedidaData, UpdateUnidadeMedidaData } from '../types/unidadesMedida';
import { CustomField, CreateCustomFieldData, UpdateCustomFieldData } from '../types/camposPersonalizados';
import { Produto, CreateProdutoData, UpdateProdutoData, ProdutoFilters } from '../types/produtos';
import { Contrato, ContratoDetalhado, CreateContratoData, UpdateContratoData, ContratoFilters, DadosRenovacao, RenovarContratoParams, HistoricoRenovacao, RenovacaoContratoResponse, ReverterRenovacaoParams, ReverterRenovacaoResponse } from '../types/contratos';
import {
  Empenho,
  CreateEmpenhoData,
  UpdateEmpenhoData,
  EmpenhoFilters,
  ItemEmpenho,
  // Novos tipos do workflow
  EmpenhoFiltrosGeral,
  SolicitacaoCompra,
  SaldoItemContrato,
  AvancarEtapaData,
  RetrocederCancelarEtapaData,
} from '../types/empenhos';
import { ProdutoOportunidade, AtualizarEtapaOportunidadeParams, MudancaEtapaOportunidadeData, CreateConfiguracaoEtapaOrcamentoData, CreateConfiguracaoValorOportunidadeData, CreateProdutoOportunidadeData, UpdateConfiguracaoEtapaOrcamentoData, UpdateConfiguracaoValorOportunidadeData, UpdateProdutoOportunidadeData, ConfiguracaoEtapaOrcamento, ConfiguracaoValorOportunidade } from '../types/orcamento';
import { Orcamento, OrcamentoDetalhado, CreateOrcamentoData, UpdateOrcamentoData, OrcamentoFilters, OrcamentoProduto, OrcamentoProdutoDetalhado, CreateOrcamentoProdutoData, UpdateOrcamentoProdutoData, OrcamentoProdutoFilters, ListarProdutosOrcamentoResponse } from '../types/orcamentos_multiplos';
import { AnexoEmpenho, AnexoEmpenhoDetalhado, CreateAnexoEmpenhoData, UpdateAnexoEmpenhoData, AnexoEmpenhoFilters } from '../types/anexos_empenhos';
import { AnexoOrcamento, AnexoOrcamentoDetalhado, AnexoOrcamentoFilters, CreateAnexoOrcamentoData, UpdateAnexoOrcamentoData } from '../types/anexos_orcamento';
import { EnderecoEntrega, CreateEnderecoEntregaData, UpdateEnderecoEntregaData, EnderecoEntregaFilters } from '../types/enderecosEntrega';
import {
  // Tipos básicos
  FinanceiroApiResponse,

  // Categorias Financeiras
  CategoriaFinanceira,
  CreateCategoriaFinanceiraData,
  UpdateCategoriaFinanceiraData,
  CategoriaFinanceiraFilters,

  // Contas Bancárias
  ContaBancaria,
  CreateContaBancariaData,
  UpdateContaBancariaData,
  AjustarSaldoContaData,
  ContaBancariaFilters,
  SaldoTotalResponse,

  // Formas de Pagamento
  FormaPagamento,
  CreateFormaPagamentoData,
  UpdateFormaPagamentoData,
  FormaPagamentoFilters,

  // Contas a Receber
  ContaReceber,
  CreateContaReceberData,
  UpdateContaReceberData,
  ProcessarRecebimentoData,
  ContaReceberFilters,
  StatusParcelasReceberResponse,

  // Contas a Pagar
  ContaPagar,
  CreateContaPagarData,
  UpdateContaPagarData,
  ProcessarPagamentoData,
  ContaPagarFilters,
  StatusParcelasPagarResponse,

  // Lançamentos Financeiros
  LancamentoFinanceiro,
  CreateLancamentoFinanceiroData,
  UpdateLancamentoFinanceiroData,
  EstornarLancamentoData,
  LancamentoFinanceiroFilters,
  LancamentosResponse,
  ResumoFinanceiro,

  // Anexos Financeiros
  AnexoFinanceiro,
  CreateAnexoFinanceiroData,
  AnexoFinanceiroFilters,
  EstatisticasAnexos,

  // Dashboard e Alertas
  DashboardAlertasResponse,

  // Status de Contratos
  StatusFinanceiroContratosResponse
} from '../types/financeiro';
import { User, UpdateUserData } from '../types/usuario';
import {
  MovimentoEstoque,
  AdicionarEstoqueData,
  AdicionarEstoqueResponse,
  HistoricoEstoqueFiltros,
  ProdutoEstoqueContrato,
  AdicionarEstoqueContratoData,
  HistoricoEstoqueProdutoParams,
  HistoricoEstoqueContratoParams,
  ItemAdicaoMultiplaEstoque,
  AdicionarMultiplosEstoqueContratoData,
  AdicionarMultiplosEstoqueResponse
} from '../types/estoque';
import {
  Usuario,
  CreateUsuarioData,
  UpdateUsuarioData,
  UsuarioFilters,
  ReativarUsuarioData,
  AcaoSistema,
  CreateAcaoSistemaData,
  UpdateAcaoSistemaData,
  ModuloSistema,
  CreateModuloSistemaData,
  UpdateModuloSistemaData,
  PerfilPermissao,
  CreatePerfilPermissaoData,
  UpdatePerfilPermissaoData,
  DuplicatePerfilData,
  PermissaoPerfil,
  CreatePermissaoPerfilData,
  UpdatePermissaoPerfilData,
  BulkPermissoesData,
  PermissaoUsuario,
  CreatePermissaoUsuarioData,
  UpdatePermissaoUsuarioData,
  RelatorioMatriz,
  RelatorioUsuariosPorPerfil,
  UsuarioSemPerfil,
  PerfilUsuario,
  UpdateUsuarioPerfilData,
  AcaoSistemaFilters,
  ModuloSistemaFilters,
  PerfilPermissaoFilters,
  PermissaoPerfilFilters,
  PermissaoUsuarioFilters,
  RelatorioMatrizFilters,
  RelatorioUsuariosPerfilFilters
} from '../types/admin';
import {
  AnexoHistoricoEstoque,
  CreateAnexoHistoricoEstoqueData,
  UpdateAnexoHistoricoEstoqueData,
  AnexoHistoricoEstoqueFilters,
  EstatisticasAnexosHistoricoEstoque
} from '../types/anexos-historico-estoque';

import {
  DashboardFaturamentoParams,
  DashboardFaturamentoResponse,
  DashboardDisputasParams,
  DashboardDisputasResponse,
  DashboardContratosAtivosParams,
  DashboardContratosAtivosResponse,
  DashboardFluxoCaixaParams,
  DashboardFluxoCaixaResponse,
  DashboardObjetivoFilters,
  DashboardObjetivosResponse,
  CreateDashboardObjetivoData,
  UpdateDashboardObjetivoData
} from '../types/dashboard';

import { API_BASE_URL } from '../environment';

// Criando uma instância do axios com configurações base
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para adicionar o token em todas as requisições
api.interceptors.request.use((config) => {
  console.log('=== REQUISIÇÃO API ===');
  console.log('URL:', config.url);
  console.log('Method:', config.method);
  console.log('Headers:', config.headers);

  const token = localStorage.getItem('token'); // Mudando de 'jwt_token' para 'token'
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Token enviado:', token.substring(0, 10) + '...');
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Interceptor para logar as respostas e tratar erros de autenticação
api.interceptors.response.use((response) => {
  console.log('=== RESPOSTA API ===');
  console.log('URL:', response.config.url);
  console.log('Status:', response.status);
  console.log('Data:', response.data);
  return response;
}, (error) => {
  console.log('=== ERRO API ===');
  console.log('URL:', error.config?.url);
  console.log('Status:', error.response?.status);
  console.log('Data:', error.response?.data);
  console.log('Error:', error.message);

  if (error.response?.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('permissions');
    delete api.defaults.headers.common['Authorization'];
    window.location.href = '/login';
  }

  return Promise.reject(error);
});

export function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

// Interfaces para as respostas da API
export interface ApiResponse<T> {
  success: boolean;
  status?: boolean; // Adicione esta linha
  data: T;
  records?: T;
  message?: string;
  pagination?: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
}

interface Licitante {
  id: number;
  nome: string;
  razao_social: string;
  cnpj: string;
  tipo: string;
  endereco: string;
  contato_principal: string;
  telefone: string;
  email: string;
  data_criacao: string;
}

interface OpportunityDetailResponse {
  id: number;
  titulo: string;
  valor_licitacao: string;
  status: OpportunityStatus;
  data_licitacao: string;
  data_abertura: string;
  id_municipio: number;
  nome_municipio: string;
  id_funil: number;
  funil_nome: string;
  id_etapa: number;
  etapa_nome: string;
  id_dono: number;
  dono_nome: string;
  id_contato: number;
  contato_nome: string;
  id_origem: number;
  origem_nome: string;
  numero_contrato: string;
  url_site_externo?: string;
  uasb?: string;
  tempo_entrega?: "Única" | "Fracionada" | "Sem informação"; // Novo campo adicionado
}



// Serviços da API
export const apiService = {

  _getDefaultValueForFieldType(tipo_campo: string, valor_padrao?: string): any {
    // Se houver um valor padrão definido, use-o
    if (valor_padrao !== undefined && valor_padrao !== null && valor_padrao !== '') {
      return valor_padrao;
    }

    // Caso contrário, use os valores padrão por tipo
    switch (tipo_campo) {
      case 'checkbox':
        return "0";
      case 'numero':
      case 'monetario':
      case 'porcentagem':
        return "0";
      case 'select':
      case 'multiselect':
      case 'radio':
        return "";
      case 'data':
        return null;
      case 'hora':
        return null;
      default:
        return "";
    }
  },


  async getContatos(filters?: ContatoFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/contatos/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<Contato[]>>(url);

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para criar um novo contato
  async createContato(data: CreateContatoData) {
    try {
      // Validações básicas
      if (!data.nome || !data.tipo_entidade) {
        throw new Error('Nome e tipo de entidade são obrigatórios');
      }

      // Validações específicas por tipo de entidade
      if (data.tipo_entidade === 'PF' && data.cpf) {
        if (data.cpf.replace(/\D/g, '').length !== 11) {
          throw new Error('CPF deve conter 11 dígitos');
        }
      }

      if (data.tipo_entidade === 'PJ' && data.cnpj) {
        if (data.cnpj.replace(/\D/g, '').length !== 14) {
          throw new Error('CNPJ deve conter 14 dígitos');
        }
      }

      const response = await api.post<ApiResponse<Contato>>('/contatos/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar contato');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para atualizar um contato existente
  async updateContato(id: number, data: Partial<CreateContatoData>) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do contato é obrigatório');
      }

      const response = await api.put<ApiResponse<Contato>>(`/contatos/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar contato');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para deletar um contato
  async deleteContato(id: number) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do contato é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/contatos/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar contato');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getMunicipios(filters?: MunicipioFilters) {
    try {
      // Create URL parameters
      const queryParams = new URLSearchParams();

      if (filters) {
        // Add each filter to query parameters if it exists
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      // Construct the URL with query parameters if they exist
      const url = `/municipios/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

      const response = await api.get<ApiResponse<Municipio[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar municípios');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para buscar um contato específico por ID
  async getContatoById(id: number) {
    try {
      const response = await api.get<ApiResponse<Contato>>(`/contatos/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Contato não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar licitantes
  async getLicitantes() {
    try {
      const response = await api.get<ApiResponse<Licitante[]>>('/licitantes/read.php');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Listar todas as origens
  async getOrigens() {
    try {
      const response = await api.get<ApiResponse<Origem[]>>('/origens/read.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar origens');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar origem específica por ID
  async getOrigemById(id: number) {
    try {
      const response = await api.get<ApiResponse<Origem>>(`/origens/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Origem não encontrada');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Adicione este método ao seu apiService
  async getOpportunities(filters: OpportunityFilters) {
    try {
      const queryParams = new URLSearchParams();

      // Adiciona cada filtro aos parâmetros de consulta
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          if (Array.isArray(value)) {
            // Para arrays, enviar múltiplos parâmetros com o mesmo nome
            value.forEach(item => {
              queryParams.append(`${key}[]`, item.toString());
            });
          } else {
            queryParams.append(key, value.toString());
          }
        }
      });

      const url = `/oportunidades/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

      const response = await api.get<ApiResponse<OpportunityDetailResponse[]>>(url);

      // Verificamos se a resposta foi bem sucedida
      const isSuccess = response.data.success !== false && response.data.status !== false;

      if (!isSuccess) {
        console.error('Erro na resposta da API:', response.data);
        throw new Error(response.data.message || 'Erro ao buscar oportunidades');
      }

      // Garantimos que os campos data e pagination sempre existam
      return {
        success: true,
        data: response.data.data || response.data.records || [],
        pagination: response.data.pagination || {
          page: 1,
          per_page: 20,
          total: 0,
          total_pages: 1
        }
      };
    } catch (error) {
      console.error('Erro na requisição getOpportunities:', error);
      throw this.handleError(error);
    }
  },

  async getOpportunitiesByStage(funnelId: number, stageId: number) {
    try {
      const response = await api.get<ApiResponse<OpportunityDetailResponse[]>>(
        `/oportunidades/read.php`,
        {
          params: {
            id_funil: funnelId,
            id_etapa: stageId
          }
        }
      );

      if (!response.data.status) {
        throw new Error(response.data.message || 'Erro ao buscar oportunidades');
      }

      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      throw this.handleError(error);
    }
  },




  // Criar nova origem
  async createOrigem(data: CreateOrigemData) {
    try {
      if (!data.nome) {
        throw new Error('Nome da origem é obrigatório');
      }

      const response = await api.post<ApiResponse<Origem>>('/origens/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar origem');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar origem existente
  async updateOrigem(id: number, data: UpdateOrigemData) {
    try {
      if (!id) {
        throw new Error('ID da origem é obrigatório');
      }

      const response = await api.put<ApiResponse<Origem>>(`/origens/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar origem');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Deletar origem
  async deleteOrigem(id: number) {
    try {
      if (!id) {
        throw new Error('ID da origem é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/origens/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar origem');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Listar todos os status de oportunidades
  async getStatusOportunidades() {
    try {
      const response = await api.get<ApiResponse<IOpportunityStatus[]>>('/status_oportunidades/read.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar status de oportunidades');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar status de oportunidade específico por ID
  async getStatusOportunidadeById(id: number) {
    try {
      const response = await api.get<ApiResponse<IOpportunityStatus>>(`/status_oportunidades/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Status de oportunidade não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar novo status de oportunidade
  async createStatusOportunidade(data: CreateOpportunityStatusData) {
    try {
      if (!data.nome) {
        throw new Error('Nome do status é obrigatório');
      }

      const response = await api.post<ApiResponse<IOpportunityStatus>>('/status_oportunidades/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar status de oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar status de oportunidade existente
  async updateStatusOportunidade(id: number, data: UpdateOpportunityStatusData) {
    try {
      if (!id) {
        throw new Error('ID do status é obrigatório');
      }

      const response = await api.put<ApiResponse<IOpportunityStatus>>(`/status_oportunidades/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar status de oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Deletar status de oportunidade
  async deleteStatusOportunidade(id: number) {
    try {
      if (!id) {
        throw new Error('ID do status é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/status_oportunidades/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar status de oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // --- MÉTODOS PARA UNIDADES DE MEDIDA ---

  // Listar todas as unidades de medida
  async getUnidadesMedida() {
    try {
      const response = await api.get<ApiResponse<IUnidadeMedida[]>>('/unidades_medida/read.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar unidades de medida');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar unidade de medida por ID
  async getUnidadeMedidaById(id: number) {
    try {
      const response = await api.get<ApiResponse<IUnidadeMedida>>(`/unidades_medida/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Unidade de medida não encontrada');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar nova unidade de medida
  async createUnidadeMedida(data: CreateUnidadeMedidaData) {
    try {
      if (!data.codigo) {
        throw new Error('O código é obrigatório');
      }

      const response = await api.post<ApiResponse<IUnidadeMedida>>('/unidades_medida/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar unidade de medida');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar unidade de medida existente
  async updateUnidadeMedida(id: number, data: UpdateUnidadeMedidaData) {
    try {
      if (!id) {
        throw new Error('ID da unidade de medida é obrigatório');
      }

      const response = await api.put<ApiResponse<IUnidadeMedida>>(`/unidades_medida/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar unidade de medida');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Deletar unidade de medida (soft delete)
  async deleteUnidadeMedida(id: number) {
    try {
      if (!id) {
        throw new Error('ID da unidade de medida é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/unidades_medida/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar unidade de medida');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // --- FIM MÉTODOS PARA UNIDADES DE MEDIDA ---


  // Método atualizado para buscar oportunidade por ID
  async getOpportunityById(id: number): Promise<{
    status: boolean;
    data: OpportunityDetail[];
    pagination?: {
      page: number;
      per_page: number;
      total: number;
      total_pages: number;
    };
  }> {
    try {
      const response = await api.get<ApiResponse<OpportunityDetail[]>>(`/oportunidades/read.php?id=${id}&id_conta=2`);

      console.log('Resposta bruta da API:', response.data);

      if (response.data.status && response.data.data.length > 0) {
        console.log('Campo UASB na resposta:', response.data.data[0].uasb);
        // Encontra a oportunidade específica pelo ID
        const opportunityFound = response.data.data.find(opp => opp.id === id);

        if (opportunityFound) {
          // Retorna apenas a oportunidade encontrada
          return {
            status: true,
            data: [opportunityFound],
            pagination: response.data.pagination
          };
        }

        throw new Error('Oportunidade específica não encontrada');
      }

      throw new Error('Oportunidade não encontrada');
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createOpportunity(data: CreateOpportunityData) {
    try {
      console.log('Iniciando criação de oportunidade com dados:', data);

      const response = await api.post<ApiResponse<any>>('/oportunidades/create.php', data);

      // Verificação adicional de sucesso
      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar oportunidade');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação de oportunidade:', error);
      throw this.handleError(error);
    }
  },

  // Método atualizado para atualizar oportunidade
  async updateOpportunity(id: number, data: CreateOpportunityData) {
    try {
      console.log('Iniciando atualização de oportunidade:', id);
      console.log('DEBUG ENVIO EDIÇÃO Opportunidade:', JSON.stringify(data, null, 2));

      // Construir URL com o ID como query parameter
      const url = `/oportunidades/update.php?id=${id}`;

      const response = await api.put<ApiResponse<any>>(url, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar oportunidade');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização da oportunidade:', error);
      throw this.handleError(error);
    }
  },


  // Método atualizado para o updateOpportunityStage
  async updateOpportunityStage(opportunityId: number, newStageId: number, observacoes?: string) {
    try {
      // Usar o novo endpoint específico para atualização de etapa
      return await this.atualizarEtapaOportunidade(opportunityId, {
        id_etapa: newStageId,
        observacoes
      });
    } catch (error) {
      console.error('Erro ao atualizar etapa:', error);
      throw this.handleError(error);
    }
  },

  // Dentro do apiService, adicione este método:
  async deleteOpportunity(id: number) {
    try {
      const response = await api.delete<ApiResponse<null>>('/oportunidades/delete.php', {
        params: { id }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar todos os funis
  async getFunis() {
    try {
      const response = await api.get<ApiResponse<Funnel[]>>('/funis/read.php');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar novo funil
  async createFunil(data: {
    nome: string;
    descricao?: string;
    ativo?: boolean;
    etapas: Array<{
      nome: string;
      descricao?: string;
    }>;
  }) {
    try {
      // Formata os dados conforme esperado pela API
      const payload = {
        ...data,
        ativo: data.ativo ? 1 : 0, // Converte boolean para 0/1
        etapas: data.etapas.map((etapa, index) => ({
          ...etapa,
          ordem: index + 1 // Adiciona ordem automaticamente
        }))
      };


      const response = await api.post<ApiResponse<{ id: number }>>('/funis/create.php', payload);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar funil');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do funil:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar funil existente
  async updateFunil(id: number, data: {
    nome: string;
    descricao?: string;
    ativo: number;
    etapas: Stage[];
  }) {
    try {
      const response = await api.put<ApiResponse<null>>('/funis/update.php', {
        id,
        ...data
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Excluir funil
  async deleteFunil(id: number) {
    try {
      const response = await api.delete<ApiResponse<null>>('/funis/delete.php', {
        data: { id }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar etapas de um funil específico
  async getEtapasFunil(id: number) {
    try {
      const response = await api.get<ApiResponse<Stage[]>>(`funis/etapas/read.php?id_funil=${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async verificarEtapaGeraContrato(idEtapa: number) {
    try {
      if (!idEtapa) {
        throw new Error('ID da etapa é obrigatório');
      }

      const response = await api.get<ApiResponse<VerificarContratoEtapaResponse>>(
        `/funis/verificar-contrato-etapa.php?id_etapa=${idEtapa}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao verificar configuração de contrato da etapa');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Atualizar configuração de geração de contrato de uma etapa
   */
  async atualizarConfiguracaoContrato(data: AtualizarConfiguracaoContratoData) {
    try {
      if (!data.id_etapa || data.gera_contrato === undefined) {
        throw new Error('ID da etapa e configuração de contrato são obrigatórios');
      }

      const response = await api.put<ApiResponse<null>>(
        '/funis/atualizar-configuracao-contrato.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar configuração de contrato');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao atualizar configuração de contrato:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Buscar relatório de configurações de contrato
   */
  async getRelatorioConfiguracoes() {
    try {
      const response = await api.get<ApiResponse<RelatorioConfiguracaoContrato[]>>(
        '/funis/relatorio-configuracoes.php'
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar relatório de configurações');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },


  // Criar uma nova anotação
  async createAnotacao(data: CreateAnotacaoData) {
    try {
      const formData = new FormData();
      formData.append('id_oportunidade', data.id_oportunidade.toString());
      formData.append('titulo', data.titulo);

      if (data.observacoes) {
        formData.append('observacoes', data.observacoes);
      }

      if (data.arquivos) {
        data.arquivos.forEach((arquivo) => {
          formData.append('arquivos[]', arquivo);
        });
      }

      const response = await api.post<ApiResponse<{
        id: number;
        data: Anotacao;
      }>>('/oportunidades/anotacoes/create.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar anotação');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação da anotação:', error);
      throw this.handleError(error);
    }
  },

  // Listar anotações de uma oportunidade
  async getAnotacoes(params: {
    id_oportunidade: number;
    page?: number;
    per_page?: number;
    search?: string;
  }) {
    try {
      const queryParams = new URLSearchParams({
        id_oportunidade: params.id_oportunidade.toString(),
        ...(params.page && { page: params.page.toString() }),
        ...(params.per_page && { per_page: params.per_page.toString() }),
        ...(params.search && { search: params.search }),
      });

      const response = await api.get<ApiResponse<Anotacao[]>>(
        `/oportunidades/anotacoes/read.php?${queryParams.toString()}`
      );

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar uma anotação existente
  async updateAnotacao(id: number, data: UpdateAnotacaoData) {
    try {
      const formData = new FormData();

      if (data.titulo) {
        formData.append('titulo', data.titulo);
      }

      if (data.observacoes) {
        formData.append('observacoes', data.observacoes);
      }

      if (data.arquivos) {
        data.arquivos.forEach((arquivo) => {
          formData.append('arquivos[]', arquivo);
        });
      }

      if (data.remover_arquivos) {
        formData.append('remover_arquivos', JSON.stringify(data.remover_arquivos));
      }

      const response = await api.post<ApiResponse<{
        data: Anotacao;
      }>>(`/oportunidades/anotacoes/update.php?id=${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar anotação');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização da anotação:', error);
      throw this.handleError(error);
    }
  },

  // Excluir uma anotação
  async deleteAnotacao(id: number) {
    try {
      const response = await api.delete<ApiResponse<null>>(
        `/oportunidades/anotacoes/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir anotação');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Download de arquivo
  async downloadArquivoAnotacao(id: number, nomeArquivo: string) {
    try {
      const response = await api.get(
        `/oportunidades/anotacoes/download.php?id=${id}&arquivo=${nomeArquivo}`,
        {
          responseType: 'blob',
        }
      );

      // Criar URL do blob e iniciar download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Upload de anexo
  async createAnexo(data: CreateAnexoData) {
    try {
      const formData = new FormData();
      formData.append('id_oportunidade', data.id_oportunidade.toString());
      formData.append('titulo', data.titulo);

      if (data.descricao) {
        formData.append('descricao', data.descricao);
      }

      formData.append('arquivo', data.arquivo);

      const response = await api.post<ApiResponse<{
        id: number;
        data: Anexo;
      }>>('/oportunidades/anexos/create.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar anexo');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do anexo:', error);
      throw this.handleError(error);
    }
  },

  // Listar anexos de uma oportunidade
  async getAnexos(params: {
    id_oportunidade: number;
    page?: number;
    per_page?: number;
    search?: string;
    tipo_arquivo?: string;
  }) {
    try {
      const queryParams = new URLSearchParams({
        id_oportunidade: params.id_oportunidade.toString(),
        ...(params.page && { page: params.page.toString() }),
        ...(params.per_page && { per_page: params.per_page.toString() }),
        ...(params.search && { search: params.search }),
        ...(params.tipo_arquivo && { tipo_arquivo: params.tipo_arquivo }),
      });

      const response = await api.get<ApiResponse<Anexo[]>>(
        `/oportunidades/anexos/read.php?${queryParams.toString()}`
      );

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar um anexo existente
  async updateAnexo(id: number, data: UpdateAnexoData) {
    try {
      const formData = new FormData();

      if (data.titulo) {
        formData.append('titulo', data.titulo);
      }

      if (data.descricao) {
        formData.append('descricao', data.descricao);
      }

      if (data.arquivo) {
        formData.append('arquivo', data.arquivo);
      }

      const response = await api.post<ApiResponse<{
        data: Anexo;
      }>>(`/oportunidades/anexos/update.php?id=${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar anexo');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do anexo:', error);
      throw this.handleError(error);
    }
  },

  // Excluir um anexo
  async deleteAnexo(id: number) {
    try {
      const response = await api.delete<ApiResponse<null>>(
        `/oportunidades/anexos/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir anexo');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Download de anexo
  async downloadAnexo(id: number, nomeOriginal: string) {
    try {
      const response = await api.get(
        `/oportunidades/anexos/download.php?id=${id}`,
        {
          responseType: 'blob',
        }
      );

      // Criar URL do blob e iniciar download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeOriginal);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getCustomFields(funilId?: number, etapaId?: number) {
    try {
      let url = '/campos-personalizados/read.php';
      const params = new URLSearchParams();

      if (funilId) params.append('id_funil', funilId.toString());
      if (etapaId) params.append('id_etapa', etapaId.toString());

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      console.log(`Buscando campos personalizados: ${url}`);

      const response = await api.get<ApiResponse<CustomField[]>>(url);

      console.log('Resposta de campos personalizados:', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar campos personalizados');
      }

      // Processamento de campos para garantir estrutura consistente
      const camposProcessados = response.data.data.map(campo => {
        // Tentar processar opcoes se for string
        if (campo.opcoes && typeof campo.opcoes === 'string') {
          try {
            campo.opcoes = JSON.parse(campo.opcoes);
          } catch (e) {
            console.error(`Erro ao processar opções do campo ${campo.id}:`, e);
            campo.opcoes = [];
          }
        }

        return campo;
      });

      return {
        ...response.data,
        data: camposProcessados
      };
    } catch (error) {
      console.error('Erro ao buscar campos personalizados:', error);
      throw this.handleError(error);
    }
  },

  // Buscar campo personalizado por ID
  async getCustomFieldById(id: number) {
    try {
      const response = await api.get<ApiResponse<CustomField>>(
        `/campos-personalizados/read.php?id=${id}`
      );

      if (!response.data.success || !response.data.data) {
        throw new Error('Campo personalizado não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Salvar valores dos campos
  async saveFieldValues(opportunityId: number, values: Array<{
    id_campo_personalizado: number;
    valor: any;
  }>) {
    try {
      console.log(`Salvando ${values.length} valores de campos para oportunidade ${opportunityId}:`, values);

      // Formatar valores para API
      const valoresFormatados = values.map(item => {
        // Se for booleano, converter para string "0" ou "1"
        if (typeof item.valor === 'boolean') {
          return {
            ...item,
            valor: item.valor ? "1" : "0"
          };
        }
        return item;
      });

      console.log('Valores formatados para API:', valoresFormatados);

      const response = await api.post<ApiResponse<any>>(
        `/campos-personalizados/valores.php?id_oportunidade=${opportunityId}`,
        { valores: valoresFormatados }
      );

      console.log('Resposta da API de salvar campos:', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao salvar valores dos campos');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao salvar valores dos campos:', error);
      throw this.handleError(error);
    }
  },

  // Criar novo campo personalizado
  async createCustomField(data: CreateCustomFieldData) {
    try {
      // Validações básicas
      if (!data.titulo || !data.tipo_campo || !data.id_funil) {
        throw new Error('Título, tipo de campo e funil são obrigatórios');
      }

      const response = await api.post<ApiResponse<CustomField>>('/campos-personalizados/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar campo personalizado');
      }

      // Se o campo foi criado para uma etapa específica
      if (data.id_etapa) {
        try {
          // Buscar oportunidades da etapa
          const opportunitiesResponse = await this.getOpportunitiesByStage(data.id_funil, data.id_etapa);

          if (opportunitiesResponse.success && opportunitiesResponse.data) {
            // Para cada oportunidade, criar valor padrão para o campo
            const createValuesPromises = opportunitiesResponse.data.map(opportunity => {
              const defaultValue = this._getDefaultValueForFieldType(data.tipo_campo, data.valor_padrao);
              console.log('Criando valor padrão:', {
                oportunidade: opportunity.id,
                campo: response.data.data.id,
                tipo: data.tipo_campo,
                valor: defaultValue
              });

              return this.saveFieldValues(opportunity.id, [{
                id_campo_personalizado: response.data.data.id,
                valor: defaultValue
              }]);
            });

            await Promise.all(createValuesPromises);
          }
        } catch (error) {
          console.error('Erro ao criar valores para oportunidades existentes:', error);
          // Não interrompe o fluxo se houver erro aqui
        }
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar campo personalizado
  async updateCustomField(id: number, data: UpdateCustomFieldData) {
    try {
      if (!id) {
        throw new Error('ID do campo é obrigatório');
      }

      const response = await api.put<ApiResponse<CustomField>>(
        `/campos-personalizados/update.php?id=${id}`,
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar campo personalizado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Excluir campo personalizado
  async deleteCustomField(id: number) {
    try {
      if (!id) {
        throw new Error('ID do campo é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(
        `/campos-personalizados/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir campo personalizado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar valores dos campos de uma oportunidade
  async getFieldValues(opportunityId: number) {
    try {
      const response = await api.get<ApiResponse<Array<{
        id_campo_personalizado: number;
        valor: any;
      }>>>(
        `/campos-personalizados/valores.php?id_oportunidade=${opportunityId}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar valores dos campos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },



  // Atualizar valores dos campos
  async updateFieldValues(opportunityId: number, values: Array<{
    id_campo_personalizado: number;
    valor: any;
  }>) {
    try {
      const response = await api.put<ApiResponse<any>>(
        `/campos-personalizados/valores.php?id_oportunidade=${opportunityId}`,
        { valores: values }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar valores dos campos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },


  // Listar todos os produtos
  async getProdutos(filters?: ProdutoFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/produtos/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<Produto[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar produtos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar produto por ID
  async getProdutoById(id: number) {
    try {
      const response = await api.get<ApiResponse<Produto>>(`/produtos/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Produto não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar múltiplos produtos por IDs (batch)
  async getProdutosByIds(ids: number[]) {
    try {
      if (ids.length === 0) return { success: true, data: [] as Produto[] };
      const uniqueIds = ids.filter((v, i, a) => a.indexOf(v) === i);
      const response = await api.get<ApiResponse<Produto[]>>(`/produtos/read.php?ids=${uniqueIds.join(',')}`);
      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar produtos');
      }
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar novo produto
  async createProduto(data: CreateProdutoData) {
    try {
      // Validações básicas
      if (!data.nome) {
        throw new Error('Nome é obrigatórios');
      }


      // Validação do estoque
      if (data.estoque !== undefined && data.estoque < 0) {
        throw new Error('O estoque não pode ser negativo');
      }

      const response = await api.post<ApiResponse<Produto>>('/produtos/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar produto');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar produto existente
  async updateProduto(id: number, data: UpdateProdutoData) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do produto é obrigatório');
      }


      // Validação do estoque
      if (data.estoque !== undefined && data.estoque < 0) {
        throw new Error('O estoque não pode ser negativo');
      }

      const response = await api.put<ApiResponse<Produto>>(`/produtos/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar produto');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Excluir produto (soft delete)
  async deleteProduto(id: number) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do produto é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/produtos/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir produto');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para trocar a senha do usuário
  async changePassword(currentPassword: string, newPassword: string) {
    try {
      // Validações básicas
      if (!currentPassword || !newPassword) {
        throw new Error('Senha atual e nova senha são obrigatórias');
      }

      // Verifica o comprimento mínimo da nova senha (exemplo de validação)
      if (newPassword.length < 6) {
        throw new Error('A nova senha deve ter no mínimo 6 caracteres');
      }

      // Obtém o token do localStorage
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token de autenticação não encontrado');
      }

      const response = await api.post<ApiResponse<any>>('/auth/trocar-senha.php', {
        token: token,
        senha_atual: currentPassword,
        nova_senha: newPassword
      });

      // Verifica se a requisição foi bem-sucedida
      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao alterar a senha');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Listar contratos com filtros opcionais
  async getContratos(filters?: ContratoFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/contratos/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<Contrato[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar contratos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter contrato específico por ID
  async getContratoById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<ApiResponse<ContratoDetalhado>>(`/contratos/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Contrato não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar novo contrato
  async createContrato(data: CreateContratoData) {
    try {
      // Validações básicas
      if (!data.id_oportunidade || !data.id_licitante || !data.data_inicio || !data.valor_total) {
        throw new Error('ID da oportunidade, ID do licitante, data de início e valor total são obrigatórios');
      }

      // Validação do valor total
      if (data.valor_total <= 0) {
        throw new Error('O valor total deve ser maior que zero');
      }

      // Validação da data de finalização (se fornecida)
      if (data.data_finalizacao && new Date(data.data_finalizacao) < new Date(data.data_inicio)) {
        throw new Error('A data de finalização deve ser igual ou posterior à data de início');
      }

      const response = await api.post<ApiResponse<{
        id: number;
        data: Contrato;
      }>>('/contratos/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar contrato');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do contrato:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar contrato existente
  async updateContrato(id: number, data: UpdateContratoData) {
    try {
      if (!id) {
        throw new Error('ID do contrato é obrigatório');
      }

      // Validação do valor total (se fornecido)
      if (data.valor_total !== undefined && data.valor_total <= 0) {
        throw new Error('O valor total deve ser maior que zero');
      }

      const response = await api.put<ApiResponse<{
        data: Contrato;
      }>>(`/contratos/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar contrato');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do contrato:', error);
      throw this.handleError(error);
    }
  },

  // Excluir contrato
  async deleteContrato(id: number) {
    try {
      if (!id) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/contratos/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir contrato');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter dados para renovação de contrato
  async getDadosRenovacao(id: number) {
    try {
      if (!id) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<FinanceiroApiResponse<DadosRenovacao>>(`/contratos/dados-renovacao.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar dados para renovação');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Renovar contrato
  async renovarContrato(data: RenovarContratoParams) {
    try {
      if (!data.id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.post<RenovacaoContratoResponse>('/contratos/renovar.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao renovar contrato');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Reverter renovação de contrato
  async reverterRenovacao(params: ReverterRenovacaoParams) {
    try {
      if (!params.id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.post<ReverterRenovacaoResponse>('/contratos/reverter-renovacao.php', params);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao reverter renovação');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter histórico de renovações
  async getHistoricoRenovacoes(id: number) {
    try {
      if (!id) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<FinanceiroApiResponse<HistoricoRenovacao[]>>(`/contratos/historico-renovacoes?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar histórico de renovações');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Listar empenhos de um contrato
  async getEmpenhos(filters: EmpenhoFilters) {
    try {
      // A API requer pelo menos id_contrato ou id específico
      if (!filters.id_contrato && !filters.id) {
        throw new Error('É necessário fornecer id_contrato ou id do empenho');
      }

      let queryParams = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const url = `/empenho/read.php?${queryParams.toString()}`;
      const response = await api.get<ApiResponse<Empenho[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar empenhos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter empenho específico por ID
  async getEmpenhoById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do empenho é obrigatório');
      }

      const response = await api.get<ApiResponse<Empenho>>(`/empenho/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Empenho não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar novo empenho
  async createEmpenho(data: CreateEmpenhoData) {
    try {
      // Validações básicas
      if (!data.id_contrato || !data.data_empenho || !data.valor_total || !data.itens || data.itens.length === 0) {
        throw new Error('ID do contrato, data do empenho, valor total e pelo menos um item são obrigatórios');
      }

      // Validação do valor total
      if (data.valor_total <= 0) {
        throw new Error('O valor total deve ser maior que zero');
      }

      // Validação dos itens
      for (const item of data.itens) {
        if (!item.id_produto || !item.quantidade || !item.valor_unitario) {
          throw new Error('Cada item deve ter um produto válido, quantidade e valor unitário');
        }

        if (item.quantidade <= 0 || item.valor_unitario <= 0) {
          throw new Error('Quantidade e valor unitário devem ser maiores que zero');
        }
      }

      const response = await api.post<ApiResponse<{
        id: number;
        data: Empenho;
      }>>('/empenho/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do empenho:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar empenho existente
  async updateEmpenho(id: number, data: UpdateEmpenhoData) {
    try {
      if (!id) {
        throw new Error('ID do empenho é obrigatório');
      }

      // Validação do valor total (se fornecido)
      if (data.valor_total !== undefined && data.valor_total <= 0) {
        throw new Error('O valor total deve ser maior que zero');
      }

      // Validação dos itens (se fornecidos)
      if (data.itens && data.itens.length > 0) {
        for (const item of data.itens) {
          if (!item.id_produto || !item.quantidade || !item.valor_unitario) {
            throw new Error('Cada item deve ter um produto válido, quantidade e valor unitário');
          }

          if (item.quantidade <= 0 || item.valor_unitario <= 0) {
            throw new Error('Quantidade e valor unitário devem ser maiores que zero');
          }
        }
      }

      const response = await api.put<ApiResponse<{
        data: Empenho;
      }>>(`/empenho/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do empenho:', error);
      throw this.handleError(error);
    }
  },

  // Excluir empenho
  async deleteEmpenho(id: number) {
    try {
      if (!id) {
        throw new Error('ID do empenho é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/empenho/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir empenho');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar um novo anexo de empenho
  async createAnexoEmpenho(data: CreateAnexoEmpenhoData) {
    try {
      // Validações básicas
      if (!data.id_empenho || !data.id_contrato || !data.titulo || !data.tipo_documento) {
        throw new Error('ID do empenho, ID do contrato, título e tipo do documento são obrigatórios');
      }

      const formData = new FormData();
      formData.append('id_empenho', data.id_empenho.toString());
      formData.append('id_contrato', data.id_contrato.toString());
      formData.append('titulo', data.titulo);

      if (data.descricao) {
        formData.append('descricao', data.descricao);
      }

      formData.append('tipo_documento', data.tipo_documento);

      if (data.arquivos && data.arquivos.length > 0) {
        data.arquivos.forEach((arquivo) => {
          formData.append('arquivos[]', arquivo);
        });
      }

      const response = await api.post<ApiResponse<{
        id: number;
      }>>('/empenho/anexos/create.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar anexo de empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do anexo de empenho:', error);
      throw this.handleError(error);
    }
  },

  // Listar anexos de um empenho específico
  async getAnexosEmpenho(params: AnexoEmpenhoFilters) {
    try {
      if (!params.id_empenho) {
        throw new Error('ID do empenho é obrigatório');
      }

      const queryParams = new URLSearchParams({
        id_empenho: params.id_empenho.toString(),
        ...(params.page && { page: params.page.toString() }),
        ...(params.per_page && { per_page: params.per_page.toString() }),
        ...(params.search && { search: params.search }),
        ...(params.tipo_documento && { tipo_documento: params.tipo_documento }),
      });

      const response = await api.get<ApiResponse<AnexoEmpenhoDetalhado[]>>(
        `/empenho/anexos/read.php?${queryParams.toString()}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar anexos do empenho');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar um anexo de empenho existente
  async updateAnexoEmpenho(id: number, data: UpdateAnexoEmpenhoData) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const formData = new FormData();
      formData.append('id', id.toString());

      if (data.titulo) {
        formData.append('titulo', data.titulo);
      }

      if (data.descricao) {
        formData.append('descricao', data.descricao);
      }

      if (data.tipo_documento) {
        formData.append('tipo_documento', data.tipo_documento);
      }

      if (data.arquivos && data.arquivos.length > 0) {
        data.arquivos.forEach((arquivo) => {
          formData.append('arquivos[]', arquivo);
        });
      }

      if (data.remover_arquivos && data.remover_arquivos.length > 0) {
        formData.append('remover_arquivos', JSON.stringify(data.remover_arquivos));
      }

      const response = await api.post<ApiResponse<null>>(
        `/empenho/anexos/update.php`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar anexo de empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do anexo de empenho:', error);
      throw this.handleError(error);
    }
  },

  // Excluir um anexo de empenho
  async deleteAnexoEmpenho(id: number) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      // Observe que o endpoint para exclusão usa POST em vez de DELETE
      const response = await api.post<ApiResponse<null>>(
        `/empenho/anexos/delete.php`,
        { id },
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir anexo de empenho');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Download de um arquivo de anexo de empenho
  async downloadArquivoAnexoEmpenho(id: number, nomeArquivo: string) {
    try {
      if (!id || !nomeArquivo) {
        throw new Error('ID do anexo e nome do arquivo são obrigatórios');
      }

      const response = await api.get(
        `/empenho/anexos/download.php?id=${id}&arquivo=${nomeArquivo}`,
        {
          responseType: 'blob',
        }
      );

      // Criar URL do blob e iniciar download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ===============================================
  // NOVOS MÉTODOS - WORKFLOW DE EMPENHOS
  // ===============================================

  // Listagem geral de empenhos (não vinculada a contrato específico)
  async getEmpenhosGeral(filtros?: EmpenhoFiltrosGeral) {
    try {
      const queryParams = new URLSearchParams();

      if (filtros) {
        if (filtros.etapa && filtros.etapa.length > 0) {
          filtros.etapa.forEach(etapa => queryParams.append('etapa[]', etapa));
        }
        if (filtros.id_contrato) {
          queryParams.append('id_contrato', filtros.id_contrato.toString());
        }
        if (filtros.data_de) {
          queryParams.append('data_de', filtros.data_de);
        }
        if (filtros.data_ate) {
          queryParams.append('data_ate', filtros.data_ate);
        }
        if (filtros.codigo_empenho) {
          queryParams.append('codigo_empenho', filtros.codigo_empenho);
        }
        if (filtros.id) {
          queryParams.append('id', filtros.id.toString());
        }
        if (filtros.page) {
          queryParams.append('page', filtros.page.toString());
        }
        if (filtros.limit) {
          queryParams.append('limit', filtros.limit.toString());
        }
      }

      const url = `/empenho/read_geral.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<Empenho[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar empenhos');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar empenhos (geral):', error);
      throw this.handleError(error);
    }
  },

  // Verificar se estoque é suficiente para todos os itens do empenho
  async verificarEstoqueEmpenho(id_empenho: number) {
    try {
      const response = await api.get(`/empenho/verificar_estoque.php?id_empenho=${id_empenho}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar estoque do empenho:', error);
      throw this.handleError(error);
    }
  },

  // Avançar etapa do empenho
  async avancarEtapaEmpenho(data: AvancarEtapaData) {
    try {
      if (!data.id_empenho) {
        throw new Error('ID do empenho é obrigatório');
      }

      const response = await api.post<ApiResponse<{ data: Empenho }>>(
        '/empenho/avancar_etapa.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao avançar etapa do empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao avançar etapa do empenho:', error);
      throw this.handleError(error);
    }
  },

  // Retroceder etapa do empenho
  async retrocederEtapaEmpenho(data: RetrocederCancelarEtapaData) {
    try {
      if (!data.id_empenho) {
        throw new Error('ID do empenho é obrigatório');
      }
      if (!data.observacoes) {
        throw new Error('Observações são obrigatórias para retroceder etapa');
      }

      const response = await api.post<ApiResponse<{ data: Empenho }>>(
        '/empenho/retroceder_etapa.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao retroceder etapa do empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao retroceder etapa do empenho:', error);
      throw this.handleError(error);
    }
  },

  // Cancelar empenho
  async cancelarEmpenho(data: RetrocederCancelarEtapaData) {
    try {
      if (!data.id_empenho) {
        throw new Error('ID do empenho é obrigatório');
      }
      if (!data.motivo && !data.observacoes) {
        throw new Error('Motivo é obrigatório para cancelar empenho');
      }

      const response = await api.post<ApiResponse<{ data: Empenho }>>(
        '/empenho/cancelar.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao cancelar empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao cancelar empenho:', error);
      throw this.handleError(error);
    }
  },

  // Obter saldo disponível de itens do contrato
  async getSaldoItensContrato(id_contrato: number) {
    try {
      if (!id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<ApiResponse<SaldoItemContrato[]>>(
        `/empenho/saldo_itens.php?id_contrato=${id_contrato}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar saldo de itens do contrato');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar saldo de itens:', error);
      throw this.handleError(error);
    }
  },

  // ===============================================
  // EMPENHO MESTRE / FILHO
  // ===============================================

  async getSaldoMaster(idEmpenho: number) {
    try {
      if (!idEmpenho) {
        throw new Error('ID do empenho é obrigatório');
      }

      const response = await api.get<ApiResponse<any[]>>(
        `/empenho/saldo_master.php?id_empenho=${idEmpenho}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar saldo do empenho mestre');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar saldo do mestre:', error);
      throw this.handleError(error);
    }
  },

  async gerarFilhoEmpenho(data: any) {
    try {
      const response = await api.post<ApiResponse<any>>(
        '/empenho/gerar_filho.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao gerar empenho filho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao gerar empenho filho:', error);
      throw this.handleError(error);
    }
  },

  // ===============================================
  // SOLICITAÇÃO DE COMPRA
  // ===============================================

  // Obter solicitação de compra por ID
  async getSolicitacaoCompra(id: number) {
    try {
      if (!id) {
        throw new Error('ID da solicitação de compra é obrigatório');
      }

      const response = await api.get<ApiResponse<SolicitacaoCompra>>(
        `/solicitacao_compra/read.php?id=${id}`
      );

      if (!response.data.success || !response.data.data) {
        throw new Error('Solicitação de compra não encontrada');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar solicitação de compra:', error);
      throw this.handleError(error);
    }
  },

  // Listar solicitações de compra
  async getSolicitacoesCompra(filtros?: { id_empenho?: number; id_contrato?: number }) {
    try {
      const queryParams = new URLSearchParams();

      if (filtros) {
        if (filtros.id_empenho) {
          queryParams.append('id_empenho', filtros.id_empenho.toString());
        }
        if (filtros.id_contrato) {
          queryParams.append('id_contrato', filtros.id_contrato.toString());
        }
      }

      const url = `/solicitacao_compra/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<SolicitacaoCompra[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar solicitações de compra');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar solicitações de compra:', error);
      throw this.handleError(error);
    }
  },

  // NOVOS ENDPOINTS - FORNECEDORES DADOS BANCÁRIOS

  // Buscar dados bancários do fornecedor
  async getDadosBancariosFornecedor(idFornecedor: number, idConta: number = 0) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('id_fornecedor', idFornecedor.toString());
      if (idConta > 0) {
        queryParams.append('id_conta', idConta.toString());
      }

      const url = `/fornecedores/dados_bancarios/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<any[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar dados bancários do fornecedor');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar dados bancários do fornecedor:', error);
      throw this.handleError(error);
    }
  },

  // Criar dados bancário do fornecedor
  async createDadosBancarios(data: any) {
    try {
      const url = '/fornecedores/dados_bancarios/create.php';
      const response = await api.post<ApiResponse<any>>(url, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar dados bancários do fornecedor');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao criar dados bancários do fornecedor:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar dados bancário do fornecedor
  async updateDadosBancarios(id: number, data: any) {
    try {
      const url = `/fornecedores/dados_bancarios/update.php?id=${id}`;
      const response = await api.put<ApiResponse<any>>(url, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar dados bancários do fornecedor');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar dados bancários do fornecedor:', error);
      throw this.handleError(error);
    }
  },

  // Excluir dados bancário do fornecedor
  async deleteDadosBancarios(id: number) {
    try {
      const url = `/fornecedores/dados_bancarios/delete.php?id=${id}`;
      const response = await api.delete<ApiResponse<any>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir dados bancários do fornecedor');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao excluir dados bancários do fornecedor:', error);
      throw this.handleError(error);
    }
  },

  // Definir como principal dados bancário
  async setPrincipalDadosBancarios(id: number, idFornecedor: number) {
    try {
      const url = `/fornecedores/dados_bancarios/set_principal.php?id=${id}&id_fornecedor=${idFornecedor}`;
      const response = await api.patch<ApiResponse<any>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro definir dados bancário como principal');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao definir dados bancário como principal:', error);
      throw this.handleError(error);
    }
  },

  // Buscar parcelas de um empenho
  async getParcelasEmpenho(idEmpenho: number) {
    try {
      const url = `/empenho/parcelas/read.php?id_empenho=${idEmpenho}`;
      const response = await api.get<ApiResponse<any[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar parcelas do empenho');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar parcelas do empenho:', error);
      throw this.handleError(error);
    }
  },

  // Criar solicitação de compra (normalmente feito automaticamente)
  async createSolicitacaoCompra(data: any) {
    try {
      const response = await api.post<ApiResponse<{ id: number; data: SolicitacaoCompra }>>(
        '/solicitacao_compra/create.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar solicitação de compra');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao criar solicitação de compra:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar solicitação de compra (apenas se PENDENTE)
  async updateSolicitacaoCompra(id: number, data: any) {
    try {
      if (!id) {
        throw new Error('ID da solicitação de compra é obrigatório');
      }

      const response = await api.put<ApiResponse<{ data: SolicitacaoCompra }>>(
        `/solicitacao_compra/update.php?id=${id}`,
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar solicitação de compra');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar solicitação de compra:', error);
      throw this.handleError(error);
    }
  },

  // Aprovar solicitação de compra (gera contas a pagar)
  async aprovarSolicitacaoCompra(id: number) {
    try {
      if (!id) {
        throw new Error('ID da solicitação de compra é obrigatório');
      }

      const response = await api.post<ApiResponse<{ data: SolicitacaoCompra }>>(
        '/solicitacao_compra/aprovar.php',
        { id }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao aprovar solicitação de compra');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao aprovar solicitação de compra:', error);
      throw this.handleError(error);
    }
  },

  // Cancelar solicitação de compra
  async cancelarSolicitacaoCompra(id: number, observacoes?: string) {
    try {
      if (!id) {
        throw new Error('ID da solicitação de compra é obrigatório');
      }

      const response = await api.post<ApiResponse<{ data: SolicitacaoCompra }>>(
        '/solicitacao_compra/cancelar.php',
        { id, observacoes }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao cancelar solicitação de compra');
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao cancelar solicitação de compra:', error);
      throw this.handleError(error);
    }
  },

  // Obter todos os produtos de uma oportunidade
  async getProdutosOportunidade(id_oportunidade: number) {
    try {
      if (!id_oportunidade) {
        throw new Error('ID da oportunidade é obrigatório');
      }

      const response = await api.get<ApiResponse<ProdutoOportunidade[]>>(
        `/produtos_oportunidade/read.php?id_oportunidade=${id_oportunidade}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar produtos da oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter um produto específico de uma oportunidade
  async getProdutoOportunidadeById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do produto da oportunidade é obrigatório');
      }

      const response = await api.get<ApiResponse<ProdutoOportunidade>>(
        `/produtos_oportunidade/read.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar produto da oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Adicionar produto a uma oportunidade
  async createProdutoOportunidade(data: CreateProdutoOportunidadeData) {
    try {
      // Validações básicas
      if (!data.id_oportunidade || !data.id_produto || !data.quantidade || !data.valor_referencia) {
        throw new Error('ID da oportunidade, ID do produto, quantidade e valor de referência são obrigatórios');
      }

      // Validação de valores positivos
      if (data.quantidade <= 0 || data.valor_referencia <= 0) {
        throw new Error('Quantidade e valor de referência devem ser maiores que zero');
      }

      const response = await api.post<ApiResponse<ProdutoOportunidade>>(
        '/produtos_oportunidade/create.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao adicionar produto à oportunidade');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao adicionar produto à oportunidade:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar produto de uma oportunidade
  async updateProdutoOportunidade(id: number, data: UpdateProdutoOportunidadeData) {
    try {
      if (!id) {
        throw new Error('ID do produto da oportunidade é obrigatório');
      }

      // Validação de valores positivos se fornecidos
      if (data.quantidade !== undefined && data.quantidade <= 0) {
        throw new Error('Quantidade deve ser maior que zero');
      }

      if (data.valor_referencia !== undefined && data.valor_referencia <= 0) {
        throw new Error('Valor de referência deve ser maior que zero');
      }

      const response = await api.put<ApiResponse<ProdutoOportunidade>>(
        `/produtos_oportunidade/update.php?id=${id}`,
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar produto da oportunidade');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao atualizar produto da oportunidade:', error);
      throw this.handleError(error);
    }
  },

  // Remover produto de uma oportunidade
  async deleteProdutoOportunidade(id: number) {
    try {
      if (!id) {
        throw new Error('ID do produto da oportunidade é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(
        `/produtos_oportunidade/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao remover produto da oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // --------- CONFIGURAÇÕES DE ETAPAS PARA ORÇAMENTO ---------

  // Obter todas as configurações de etapas para orçamento
  async getConfiguracoesEtapasOrcamento(id_funil?: number) {
    try {
      let url = '/configuracoes_etapas_orcamento/read.php';

      if (id_funil) {
        url += `?id_funil=${id_funil}`;
      }

      const response = await api.get<ApiResponse<ConfiguracaoEtapaOrcamento[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar configurações de etapas para orçamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter configuração específica por ID
  async getConfiguracaoEtapaOrcamentoById(id: number) {
    try {
      if (!id) {
        throw new Error('ID da configuração é obrigatório');
      }

      const response = await api.get<ApiResponse<ConfiguracaoEtapaOrcamento>>(
        `/configuracoes_etapas_orcamento/read.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar configuração de etapa para orçamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter configuração específica por funil e etapa
  async getConfiguracaoEtapaOrcamentoByFunilEtapa(id_funil: number, id_etapa: number) {
    try {
      if (!id_funil || !id_etapa) {
        throw new Error('ID do funil e ID da etapa são obrigatórios');
      }

      const response = await api.get<ApiResponse<ConfiguracaoEtapaOrcamento>>(
        `/configuracoes_etapas_orcamento/read.php?id_funil=${id_funil}&id_etapa=${id_etapa}`
      );

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar configuração de etapa para orçamento
  async createConfiguracaoEtapaOrcamento(data: CreateConfiguracaoEtapaOrcamentoData) {
    try {
      // Validações básicas
      if (!data.id_funil || !data.id_etapa) {
        throw new Error('ID do funil e ID da etapa são obrigatórios');
      }

      const response = await api.post<ApiResponse<ConfiguracaoEtapaOrcamento>>(
        '/configuracoes_etapas_orcamento/create.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar configuração de etapa para orçamento');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao criar configuração de etapa para orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar configuração de etapa para orçamento
  async updateConfiguracaoEtapaOrcamento(id: number, data: UpdateConfiguracaoEtapaOrcamentoData) {
    try {
      if (!id) {
        throw new Error('ID da configuração é obrigatório');
      }

      const response = await api.put<ApiResponse<ConfiguracaoEtapaOrcamento>>(
        `/configuracoes_etapas_orcamento/update.php?id=${id}`,
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar configuração de etapa para orçamento');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao atualizar configuração de etapa para orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Excluir configuração de etapa para orçamento
  async deleteConfiguracaoEtapaOrcamento(id: number) {
    try {
      if (!id) {
        throw new Error('ID da configuração é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(
        `/configuracoes_etapas_orcamento/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir configuração de etapa para orçamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // --------- ORÇAMENTOS (MÚLTIPLOS) ---------

  // Listar orçamentos de uma oportunidade
  async getOrcamentos(filters: OrcamentoFilters) {
    try {
      // Validação: id_oportunidade é obrigatório para listar orçamentos
      if (!filters.id_oportunidade && !filters.id) {
        throw new Error('ID da oportunidade ou ID do orçamento é obrigatório');
      }

      // Construir query params
      const params = new URLSearchParams();
      if (filters.id) {
        params.append('id', filters.id.toString());
      }
      if (filters.id_oportunidade) {
        params.append('id_oportunidade', filters.id_oportunidade.toString());
      }
      if (filters.fornecedor_id) {
        params.append('fornecedor_id', filters.fornecedor_id.toString());
      }
      if (filters.status) {
        params.append('status', filters.status);
      }

      const url = `/orcamentos/read.php${params.toString() ? `?${params.toString()}` : ''}`;
      const response = await api.get<ApiResponse<OrcamentoDetalhado[] | OrcamentoDetalhado>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar orçamentos');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao buscar orçamentos:', error);
      throw this.handleError(error);
    }
  },

  // Buscar orçamento específico por ID
  async getOrcamentoById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do orçamento é obrigatório');
      }

      const response = await api.get<ApiResponse<OrcamentoDetalhado>>(
        `/orcamentos/read.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar orçamento');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao buscar orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Criar novo orçamento
  async createOrcamento(data: CreateOrcamentoData) {
    try {
      // Validações básicas
      if (!data.id_oportunidade) {
        throw new Error('ID da oportunidade é obrigatório');
      }
      if (!data.titulo) {
        throw new Error('Título do orçamento é obrigatório');
      }

      const response = await api.post<ApiResponse<OrcamentoDetalhado>>(
        '/orcamentos/create.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar orçamento');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao criar orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar orçamento existente
  async updateOrcamento(id: number, data: UpdateOrcamentoData) {
    try {
      if (!id) {
        throw new Error('ID do orçamento é obrigatório');
      }

      // Validações de valores se fornecidos
      if (data.valor_total !== undefined && data.valor_total < 0) {
        throw new Error('Valor total não pode ser negativo');
      }

      // Adicionar o ID ao body do request (conforme documentação da API)
      const requestData = {
        id: id,
        ...data
      };

      const response = await api.put<ApiResponse<OrcamentoDetalhado>>(
        `/orcamentos/update.php`,
        requestData
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar orçamento');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao atualizar orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Excluir orçamento (soft delete)
  async deleteOrcamento(id: number) {
    try {
      if (!id) {
        throw new Error('ID do orçamento é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(
        `/orcamentos/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir orçamento');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao excluir orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Listar produtos de um orçamento
  async getOrcamentoProdutos(filters: OrcamentoProdutoFilters) {
    try {
      // Validação: id_orcamento é obrigatório para listar produtos
      if (!filters.id_orcamento && !filters.id) {
        throw new Error('ID do orçamento ou ID do produto é obrigatório');
      }

      // Construir query params
      const params = new URLSearchParams();
      if (filters.id) {
        params.append('id', filters.id.toString());
      }
      if (filters.id_orcamento) {
        params.append('id_orcamento', filters.id_orcamento.toString());
      }

      const url = `/orcamentos/produtos/read.php${params.toString() ? `?${params.toString()}` : ''}`;

      // Se buscar por id específico, retorna apenas um produto
      if (filters.id) {
        const response = await api.get<ApiResponse<OrcamentoProdutoDetalhado>>(url);

        if (!response.data.success) {
          throw new Error(response.data.message || 'Erro ao buscar produto do orçamento');
        }

        return response.data;
      } else {
        // Se buscar por id_orcamento, retorna lista com total_geral
        const response = await api.get<ListarProdutosOrcamentoResponse>(url);

        if (!response.data.success) {
          throw new Error(response.data.message || 'Erro ao buscar produtos do orçamento');
        }

        return response.data;
      }
    } catch (error) {
      console.log('Erro ao buscar produtos do orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Adicionar produto ao orçamento
  async createOrcamentoProduto(data: CreateOrcamentoProdutoData) {
    try {
      // Validações básicas
      if (!data.id_orcamento) {
        throw new Error('ID do orçamento é obrigatório');
      }
      if (!data.id_produto_oportunidade) {
        throw new Error('ID do produto da oportunidade é obrigatório');
      }
      if (!data.quantidade) {
        throw new Error('Quantidade é obrigatória');
      }
      if (data.valor_unitario === undefined || data.valor_unitario === null) {
        throw new Error('Valor unitário é obrigatório');
      }

      // Validações de valores positivos
      if (data.quantidade <= 0) {
        throw new Error('Quantidade deve ser maior que zero');
      }
      if (data.valor_unitario < 0) {
        throw new Error('Valor unitário não pode ser negativo');
      }

      const response = await api.post<ApiResponse<OrcamentoProdutoDetalhado>>(
        '/orcamentos/produtos/create.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao adicionar produto ao orçamento');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao adicionar produto ao orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar produto do orçamento
  async updateOrcamentoProduto(id: number, data: UpdateOrcamentoProdutoData) {
    try {
      if (!id) {
        throw new Error('ID do produto do orçamento é obrigatório');
      }

      // Validações de valores se fornecidos
      if (data.quantidade !== undefined && data.quantidade <= 0) {
        throw new Error('Quantidade deve ser maior que zero');
      }
      if (data.valor_unitario !== undefined && data.valor_unitario < 0) {
        throw new Error('Valor unitário não pode ser negativo');
      }

      // Adicionar o ID ao body do request (conforme documentação da API)
      const requestData = {
        id: id,
        ...data
      };

      const response = await api.put<ApiResponse<OrcamentoProdutoDetalhado>>(
        `/orcamentos/produtos/update.php`,
        requestData
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar produto do orçamento');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao atualizar produto do orçamento:', error);
      throw this.handleError(error);
    }
  },

  // Remover produto do orçamento
  async deleteOrcamentoProduto(id: number) {
    try {
      if (!id) {
        throw new Error('ID do produto do orçamento é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(
        `/orcamentos/produtos/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao remover produto do orçamento');
      }

      return response.data;
    } catch (error) {
      console.log('Erro ao remover produto do orçamento:', error);
      throw this.handleError(error);
    }
  },

  // --------- CONFIGURAÇÕES DE VALOR DA OPORTUNIDADE ---------

  // Obter todas as configurações de valor da oportunidade
  async getConfiguracoesValorOportunidade() {
    try {
      const response = await api.get<ApiResponse<ConfiguracaoValorOportunidade[]>>(
        '/configuracoes_valor_oportunidade/read.php'
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar configurações de valor da oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter configuração específica por ID
  async getConfiguracaoValorOportunidadeById(id: number) {
    try {
      if (!id) {
        throw new Error('ID da configuração é obrigatório');
      }

      const response = await api.get<ApiResponse<ConfiguracaoValorOportunidade>>(
        `/configuracoes_valor_oportunidade/read.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar configuração de valor da oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Obter configuração específica por funil
  async getConfiguracaoValorOportunidadeByFunil(id_funil: number) {
    try {
      if (!id_funil) {
        throw new Error('ID do funil é obrigatório');
      }

      const response = await api.get<ApiResponse<ConfiguracaoValorOportunidade>>(
        `/configuracoes_valor_oportunidade/read.php?id_funil=${id_funil}`
      );

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar configuração de valor da oportunidade
  async createConfiguracaoValorOportunidade(data: CreateConfiguracaoValorOportunidadeData) {
    try {
      // Validações básicas
      if (!data.id_funil || !data.id_etapa_mudanca_valor) {
        throw new Error('ID do funil e ID da etapa de mudança de valor são obrigatórios');
      }

      const response = await api.post<ApiResponse<ConfiguracaoValorOportunidade>>(
        '/configuracoes_valor_oportunidade/create.php',
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar configuração de valor da oportunidade');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao criar configuração de valor da oportunidade:', error);
      throw this.handleError(error);
    }
  },

  // Atualizar configuração de valor da oportunidade
  async updateConfiguracaoValorOportunidade(id: number, data: UpdateConfiguracaoValorOportunidadeData) {
    try {
      if (!id) {
        throw new Error('ID da configuração é obrigatório');
      }

      const response = await api.put<ApiResponse<ConfiguracaoValorOportunidade>>(
        `/configuracoes_valor_oportunidade/update.php?id=${id}`,
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar configuração de valor da oportunidade');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao atualizar configuração de valor da oportunidade:', error);
      throw this.handleError(error);
    }
  },

  // Excluir configuração de valor da oportunidade
  async deleteConfiguracaoValorOportunidade(id: number) {
    try {
      if (!id) {
        throw new Error('ID da configuração é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(
        `/configuracoes_valor_oportunidade/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir configuração de valor da oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async atualizarEtapaOportunidade(opportunityId: number, data: AtualizarEtapaOportunidadeParams) {
    try {
      console.log('Atualizando etapa da oportunidade:', opportunityId);

      const url = `/oportunidades/atualizar_etapa.php?id=${opportunityId}`;

      const response = await api.post<ApiResponse<{
        valor_mudou: boolean;
        data: {
          id: number;
          titulo: string;
          id_funil: number;
          nome_funil: string;
          id_etapa: number;
          nome_etapa: string;
          status: string;
          valor_licitacao: number;
          valor_total_proposta: number;
          utiliza_valor_proposta: boolean;
          tempo_entrega?: "Única" | "Fracionada" | "Sem informação"; // Novo campo adicionado
        }
      }>>(url, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar etapa da oportunidade');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao atualizar etapa da oportunidade:', error);
      throw this.handleError(error);
    }
  },


  // Listar todos os fornecedores com filtros opcionais
  async getFornecedores(filters?: FornecedorFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/fornecedores/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<Fornecedor[]>>(url);

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para buscar um fornecedor específico por ID
  async getFornecedorById(id: number) {
    try {
      const response = await api.get<ApiResponse<Fornecedor>>(`/fornecedores/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Fornecedor não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para criar um novo fornecedor
  async createFornecedor(data: CreateFornecedorData) {
    try {
      // Validações básicas
      if (!data.nome || !data.tipo_entidade) {
        throw new Error('Nome e tipo de entidade são obrigatórios');
      }

      // Validações específicas por tipo de entidade
      if (data.tipo_entidade === 'PF' && data.cpf) {
        if (data.cpf.replace(/\D/g, '').length !== 11) {
          throw new Error('CPF deve conter 11 dígitos');
        }
      }

      if (data.tipo_entidade === 'PJ' && data.cnpj) {
        if (data.cnpj.replace(/\D/g, '').length !== 14) {
          throw new Error('CNPJ deve conter 14 dígitos');
        }
      }

      const response = await api.post<ApiResponse<Fornecedor>>('/fornecedores/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar fornecedor');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para atualizar um fornecedor existente
  async updateFornecedor(id: number, data: Partial<CreateFornecedorData>) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do fornecedor é obrigatório');
      }

      const response = await api.put<ApiResponse<Fornecedor>>(`/fornecedores/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar fornecedor');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Método para deletar um fornecedor
  async deleteFornecedor(id: number) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do fornecedor é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/fornecedores/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar fornecedor');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getEnderecosEntrega(filters?: EnderecoEntregaFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/enderecos_entrega/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<EnderecoEntrega[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar endereços de entrega');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Buscar endereço de entrega específico por ID
   */
  async getEnderecoEntregaById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do endereço é obrigatório');
      }

      const response = await api.get<ApiResponse<EnderecoEntrega>>(`/enderecos_entrega/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Endereço de entrega não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Listar endereços de entrega por oportunidade
   */
  async getEnderecosEntregaByOportunidade(id_oportunidade: number) {
    try {
      if (!id_oportunidade) {
        throw new Error('ID da oportunidade é obrigatório');
      }

      const response = await api.get<ApiResponse<EnderecoEntrega[]>>(
        `/enderecos_entrega/read.php?id_oportunidade=${id_oportunidade}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar endereços da oportunidade');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Criar novo endereço de entrega
   */
  async createEnderecoEntrega(data: CreateEnderecoEntregaData) {
    try {
      // Validações básicas
      if (!data.id_oportunidade || !data.nome || !data.endereco) {
        throw new Error('ID da oportunidade, nome e endereço são obrigatórios');
      }

      const response = await api.post<ApiResponse<{
        id: number;
        data: EnderecoEntrega;
      }>>('/enderecos_entrega/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar endereço de entrega');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do endereço de entrega:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Atualizar endereço de entrega existente
   */
  async updateEnderecoEntrega(id: number, data: UpdateEnderecoEntregaData) {
    try {
      if (!id) {
        throw new Error('ID do endereço é obrigatório');
      }

      const response = await api.put<ApiResponse<{
        data: EnderecoEntrega;
      }>>(`/enderecos_entrega/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar endereço de entrega');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do endereço de entrega:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Excluir endereço de entrega
   */
  async deleteEnderecoEntrega(id: number) {
    try {
      if (!id) {
        throw new Error('ID do endereço é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/enderecos_entrega/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir endereço de entrega');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Listar anexos de orçamento com filtros opcionais
   */
  async getAnexosOrcamento(filters: AnexoOrcamentoFilters) {
    try {
      const queryParams = new URLSearchParams();

      // Adiciona cada filtro aos parâmetros de consulta se existir
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const url = `/oportunidades/anexos_orcamento/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<AnexoOrcamento[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar anexos de orçamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Buscar anexo de orçamento específico por ID
   */
  async getAnexoOrcamentoById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const response = await api.get<ApiResponse<AnexoOrcamentoDetalhado>>(`/oportunidades/anexos_orcamento/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Anexo de orçamento não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Criar novo anexo de orçamento
   */
  async createAnexoOrcamento(data: CreateAnexoOrcamentoData) {
    try {
      // Validações básicas
      if (!data.id_oportunidade || !data.titulo || !data.arquivo) {
        throw new Error('ID da oportunidade, título e arquivo são obrigatórios');
      }

      console.log(data)

      const formData = new FormData();
      formData.append('id_oportunidade', data.id_oportunidade.toString());
      formData.append('titulo', data.titulo);

      if (data.descricao) {
        formData.append('descricao', data.descricao);
      }

      if (data.tipo_documento) {
        formData.append('tipo_documento', data.tipo_documento);
      }

      // Apenas adiciona se existir
      if (data.id_produto_oportunidade) {
        formData.append('id_produto_oportunidade', data.id_produto_oportunidade.toString());
      }

      // Apenas adiciona se existir
      if (data.id_fornecedor) {
        formData.append('id_fornecedor', data.id_fornecedor.toString());
      }

      formData.append('arquivo', data.arquivo);

      const response = await api.post<ApiResponse<{
        id: number;
        data: AnexoOrcamento;
      }>>('/oportunidades/anexos_orcamento/create.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar anexo de orçamento');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do anexo de orçamento:', error);
      throw this.handleError(error);
    }
  },

  async updateAnexoOrcamento(id: number, data: UpdateAnexoOrcamentoData) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const formData = new FormData();
      formData.append('id', id.toString());

      if (data.titulo) {
        formData.append('titulo', data.titulo);
      }

      if (data.descricao !== undefined) {
        formData.append('descricao', data.descricao);
      }

      if (data.tipo_documento) {
        formData.append('tipo_documento', data.tipo_documento);
      }

      // Apenas adiciona se existir
      if (data.id_produto_oportunidade) {
        formData.append('id_produto_oportunidade', data.id_produto_oportunidade.toString());
      }

      // Apenas adiciona se existir
      if (data.id_fornecedor) {
        formData.append('id_fornecedor', data.id_fornecedor.toString());
      }

      if (data.arquivo) {
        formData.append('arquivo', data.arquivo);
      }

      const response = await api.post<ApiResponse<{
        data: AnexoOrcamento;
      }>>('/oportunidades/anexos_orcamento/update.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar anexo de orçamento');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do anexo de orçamento:', error);
      throw this.handleError(error);
    }
  },
  /**
   * Excluir anexo de orçamento
   */
  async deleteAnexoOrcamento(id: number) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const response = await api.post<ApiResponse<null>>(
        '/oportunidades/anexos_orcamento/delete.php',
        { id },
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir anexo de orçamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Download de anexo de orçamento
   */
  async downloadAnexoOrcamento(id: number) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      // Primeiro, buscar os detalhes do anexo para obter o nome do arquivo original
      const anexoResponse = await this.getAnexoOrcamentoById(id);
      const nomeArquivo = anexoResponse.success && anexoResponse.data ?
        anexoResponse.data.nome_arquivo : `anexo-${id}`;

      const response = await api.get(
        `/oportunidades/anexos_orcamento/download.php?id=${id}`,
        {
          responseType: 'blob',
        }
      );

      // Criar URL do blob e iniciar download
      const contentType = response.headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - CATEGORIAS
  // ============================================================================

  async getCategoriaFinanceira(filters?: CategoriaFinanceiraFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/financeiro/categorias/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<FinanceiroApiResponse<CategoriaFinanceira[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar categorias financeiras');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createCategoriaFinanceira(data: CreateCategoriaFinanceiraData) {
    try {
      if (!data.nome || !data.tipo) {
        throw new Error('Nome e tipo são obrigatórios');
      }

      const response = await api.post<FinanceiroApiResponse<CategoriaFinanceira>>('/financeiro/categorias/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar categoria financeira');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async updateCategoriaFinanceira(id: number, data: UpdateCategoriaFinanceiraData) {
    try {
      if (!id) {
        throw new Error('ID da categoria é obrigatório');
      }

      const response = await api.put<FinanceiroApiResponse<CategoriaFinanceira>>(`/financeiro/categorias/update.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar categoria financeira');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async deleteCategoriaFinanceira(id: number) {
    try {
      if (!id) {
        throw new Error('ID da categoria é obrigatório');
      }

      const response = await api.delete<FinanceiroApiResponse<null>>(`/financeiro/categorias/delete.php/${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar categoria financeira');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - CONTAS BANCÁRIAS
  // ============================================================================

  async getContasBancarias(filters?: ContaBancariaFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/financeiro/contas_bancarias/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

      if (filters?.apenas_saldo) {
        const response = await api.get<FinanceiroApiResponse<SaldoTotalResponse>>(url);
        return response.data;
      } else {
        const response = await api.get<FinanceiroApiResponse<ContaBancaria[]>>(url);
        return response.data;
      }
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createContaBancaria(data: CreateContaBancariaData) {
    try {
      if (!data.nome || !data.banco || !data.agencia || !data.conta) {
        throw new Error('Nome, banco, agência e conta são obrigatórios');
      }

      const response = await api.post<FinanceiroApiResponse<ContaBancaria>>('/financeiro/contas_bancarias/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar conta bancária');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async updateContaBancaria(id: number, data: UpdateContaBancariaData) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      const response = await api.put<FinanceiroApiResponse<ContaBancaria>>(`/financeiro/contas_bancarias/update.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar conta bancária');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async ajustarSaldoConta(id: number, data: AjustarSaldoContaData) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      if (data.novo_saldo === undefined || data.novo_saldo === null) {
        throw new Error('Novo saldo é obrigatório');
      }

      // 🔍 DEBUG: Log antes da requisição para debugging
      console.log('🔍 DEBUG ajustarSaldoConta:', {
        id: id,
        url: `/financeiro/contas_bancarias/ajustar_saldo.php/${id}`,
        data: data
      });

      const response = await api.post<FinanceiroApiResponse<ContaBancaria>>(`/financeiro/contas_bancarias/ajustar_saldo.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao ajustar saldo da conta');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - CONTAS A RECEBER
  // ============================================================================

  async getContasReceber(filters?: ContaReceberFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/financeiro/contas_receber/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<FinanceiroApiResponse<ContaReceber[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar contas a receber');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createContaReceber(data: CreateContaReceberData) {
    try {
      if (!data.id_contato || !data.id_categoria || !data.descricao || !data.valor_original) {
        throw new Error('Contato, categoria, descrição e valor são obrigatórios');
      }

      if (data.valor_original <= 0) {
        throw new Error('Valor deve ser maior que zero');
      }

      const response = await api.post<FinanceiroApiResponse<ContaReceber>>('/financeiro/contas_receber/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar conta a receber');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async updateContaReceber(id: number, data: UpdateContaReceberData) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      const response = await api.put<FinanceiroApiResponse<ContaReceber>>(`/financeiro/contas_receber/update.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar conta a receber');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async deleteContaReceber(id: number) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      const response = await api.delete<FinanceiroApiResponse<null>>(`/financeiro/contas_receber/delete.php/${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar conta a receber');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async processarRecebimento(id: number, data: ProcessarRecebimentoData) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      if (!data.valor || !data.id_forma_pagamento || !data.data_recebimento) {
        throw new Error('Valor, forma de pagamento e data são obrigatórios');
      }

      if (data.valor <= 0) {
        throw new Error('Valor deve ser maior que zero');
      }

      const response = await api.post<FinanceiroApiResponse<ContaReceber>>(`/financeiro/contas_receber/receber.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao processar recebimento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getStatusParcelasReceber(id_contrato: number) {
    try {
      if (!id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<FinanceiroApiResponse<StatusParcelasReceberResponse>>(`/financeiro/contas_receber/status_parcelas.php/${id_contrato}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar status das parcelas');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - CONTAS A PAGAR
  // ============================================================================

  async getContasPagar(filters?: ContaPagarFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/financeiro/contas_pagar/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<FinanceiroApiResponse<ContaPagar[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar contas a pagar');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createContaPagar(data: CreateContaPagarData) {
    try {
      if (!data.id_fornecedor || !data.id_categoria || !data.descricao || !data.valor_original) {
        throw new Error('Fornecedor, categoria, descrição e valor são obrigatórios');
      }

      if (data.valor_original <= 0) {
        throw new Error('Valor deve ser maior que zero');
      }

      const response = await api.post<FinanceiroApiResponse<ContaPagar>>('/financeiro/contas_pagar/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar conta a pagar');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async updateContaPagar(id: number, data: UpdateContaPagarData) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      const response = await api.put<FinanceiroApiResponse<ContaPagar>>(`/financeiro/contas_pagar/update.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar conta a pagar');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async deleteContaPagar(id: number) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      const response = await api.delete<FinanceiroApiResponse<null>>(`/financeiro/contas_pagar/delete.php/${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar conta a pagar');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async processarPagamento(id: number, data: ProcessarPagamentoData) {
    try {
      if (!id) {
        throw new Error('ID da conta é obrigatório');
      }

      if (!data.valor || !data.id_forma_pagamento || !data.data_pagamento) {
        throw new Error('Valor, forma de pagamento e data são obrigatórios');
      }

      if (data.valor <= 0) {
        throw new Error('Valor deve ser maior que zero');
      }

      const response = await api.post<FinanceiroApiResponse<ContaPagar>>(`/financeiro/contas_pagar/pagar.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao processar pagamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getStatusParcelasPagar(id_contrato: number) {
    try {
      if (!id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<FinanceiroApiResponse<StatusParcelasPagarResponse>>(`/financeiro/contas_pagar/status_parcelas.php/${id_contrato}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar status das parcelas de pagamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - LANÇAMENTOS FINANCEIROS
  // ============================================================================

  async getLancamentosFinanceiros(filters?: LancamentoFinanceiroFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/financeiro/lancamentos/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<FinanceiroApiResponse<LancamentosResponse>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar lançamentos financeiros');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createLancamentoFinanceiro(data: CreateLancamentoFinanceiroData) {
    try {
      if (!data.data_lancamento || !data.descricao || !data.valor || !data.tipo) {
        throw new Error('Data, descrição, valor e tipo são obrigatórios');
      }

      if (data.valor <= 0) {
        throw new Error('Valor deve ser maior que zero');
      }

      const response = await api.post<FinanceiroApiResponse<LancamentoFinanceiro>>('/financeiro/lancamentos/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar lançamento financeiro');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async updateLancamentoFinanceiro(id: number, data: UpdateLancamentoFinanceiroData) {
    try {
      if (!id) {
        throw new Error('ID do lançamento é obrigatório');
      }

      const response = await api.put<FinanceiroApiResponse<LancamentoFinanceiro>>(`/financeiro/lancamentos/update.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar lançamento financeiro');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async deleteLancamentoFinanceiro(id: number) {
    try {
      if (!id) {
        throw new Error('ID do lançamento é obrigatório');
      }

      const response = await api.delete<FinanceiroApiResponse<null>>(`/financeiro/lancamentos/delete.php/${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar lançamento financeiro');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async estornarLancamento(id: number, data: EstornarLancamentoData) {
    try {
      if (!id) {
        throw new Error('ID do lançamento é obrigatório');
      }

      if (!data.motivo_estorno) {
        throw new Error('Motivo do estorno é obrigatório');
      }

      const response = await api.post<FinanceiroApiResponse<LancamentoFinanceiro>>(`/financeiro/lancamentos/estornar.php/${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao estornar lançamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getResumoFinanceiro(data_inicio?: string, data_fim?: string) {
    try {
      let queryParams = new URLSearchParams();

      if (data_inicio) queryParams.append('data_inicio', data_inicio);
      if (data_fim) queryParams.append('data_fim', data_fim);

      const url = `/financeiro/lancamentos/resumo.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<FinanceiroApiResponse<ResumoFinanceiro>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar resumo financeiro');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - ANEXOS FINANCEIROS
  // ============================================================================

  async getAnexosFinanceiros(filters?: AnexoFinanceiroFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/financeiro/anexos/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<FinanceiroApiResponse<AnexoFinanceiro[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar anexos financeiros');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createAnexoFinanceiro(data: CreateAnexoFinanceiroData) {
    try {
      if (!data.arquivo || !data.tipo_origem || !data.id_origem || !data.titulo) {
        throw new Error('Arquivo, tipo de origem, ID de origem e título são obrigatórios');
      }

      const formData = new FormData();
      formData.append('arquivo', data.arquivo);
      formData.append('tipo_origem', data.tipo_origem);
      formData.append('id_origem', data.id_origem.toString());
      formData.append('titulo', data.titulo);

      if (data.descricao) {
        formData.append('descricao', data.descricao);
      }

      const response = await api.post<FinanceiroApiResponse<AnexoFinanceiro>>('/financeiro/anexos/create.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar anexo financeiro');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async deleteAnexoFinanceiro(id: number) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const response = await api.delete<FinanceiroApiResponse<null>>(`/financeiro/anexos/delete.php/${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar anexo financeiro');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async downloadAnexoFinanceiro(id: number, nomeOriginal: string) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const response = await api.get(`/financeiro/anexos/download.php/${id}`, {
        responseType: 'blob',
      });

      // Criar URL do blob e iniciar download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeOriginal);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getEstatisticasAnexos() {
    try {
      const response = await api.get<FinanceiroApiResponse<EstatisticasAnexos>>('/financeiro/anexos/estatisticas.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar estatísticas de anexos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - STATUS FINANCEIRO DE CONTRATOS
  // ============================================================================

  async getStatusFinanceiroContratos() {
    try {
      const response = await api.get<FinanceiroApiResponse<StatusFinanceiroContratosResponse>>('/financeiro/contratos/status_financeiro.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar status financeiro dos contratos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO FINANCEIRO - DASHBOARD E ALERTAS
  // ============================================================================

  async getDashboardAlertas() {
    try {
      const response = await api.get<FinanceiroApiResponse<DashboardAlertasResponse>>('/financeiro/dashboard/alertas.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar alertas do dashboard');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE USUÁRIO / PERFIL
  // ============================================================================

  /**
   * Busca os dados do perfil do usuário logado.
   */
  async getMyProfile(): Promise<ApiResponse<User>> { // <--- Alterado para User
    try {
      // A lógica interna permanece a mesma
      const response = await api.get<ApiResponse<User>>('/usuarios/meu-perfil.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar dados do perfil');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza os dados do perfil do usuário logado.
   * @param data - Os dados a serem atualizados.
   */
  async updateMyProfile(data: UpdateUserData): Promise<ApiResponse<User>> { // <--- Alterado aqui
    try {
      // A lógica interna com FormData permanece a mesma
      const formData = new FormData();

      Object.keys(data).forEach(key => {
        if (key !== 'foto_perfil') {
          const value = data[key as keyof Omit<UpdateUserData, 'foto_perfil'>];
          if (value !== null && value !== undefined) {
            formData.append(key, value);
          }
        }
      });

      if (data.foto_perfil) {
        formData.append('foto_perfil', data.foto_perfil);
      }

      const response = await api.post<ApiResponse<User>>( // <--- Alterado aqui
        '/usuarios/meu-perfil.php',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar o perfil');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Desativa (soft delete) a conta do usuário logado.
   */
  async deleteMyAccount(): Promise<ApiResponse<null>> {
    // Nenhuma mudança de tipo aqui
    try {
      const response = await api.delete<ApiResponse<null>>('/usuarios/meu-perfil.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao desativar a conta');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ESTOQUE
  // ============================================================================

  /**
   * Adiciona estoque manualmente a um produto específico
   */
  async adicionarEstoqueProduto(id: number, data: AdicionarEstoqueData) {
    try {
      // Validações básicas
      if (!id) {
        throw new Error('ID do produto é obrigatório');
      }

      if (!data.quantidade || !data.motivo) {
        throw new Error('Quantidade e motivo são obrigatórios');
      }

      if (data.quantidade <= 0) {
        throw new Error('Quantidade deve ser maior que zero');
      }

      const response = await api.post<ApiResponse<AdicionarEstoqueResponse>>(
        `/produtos/estoque/adicionar.php?id=${id}`,
        data
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao adicionar estoque ao produto');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao adicionar estoque ao produto:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Busca o histórico de movimentações de um produto específico
   */
  async getHistoricoEstoqueProduto(id_produto: number, limite?: number) {
    try {
      if (!id_produto) {
        throw new Error('ID do produto é obrigatório');
      }

      const queryParams = new URLSearchParams({
        id_produto: id_produto.toString(),
        ...(limite && { limite: limite.toString() })
      });

      const response = await api.get<ApiResponse<MovimentoEstoque[]>>(
        `/estoque/historico/produto.php?${queryParams.toString()}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar histórico de estoque do produto');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca o histórico de movimentações de estoque de um contrato específico
   */
  async getHistoricoEstoqueContrato(id_contrato: number) {
    try {
      if (!id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<ApiResponse<MovimentoEstoque[]>>(
        `/estoque/historico/contrato.php?id_contrato=${id_contrato}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar histórico de estoque do contrato');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Gera relatório geral de movimentações com filtros opcionais
   */
  async getRelatorioEstoque(filtros?: HistoricoEstoqueFiltros) {
    try {
      let queryParams = new URLSearchParams();

      if (filtros) {
        Object.entries(filtros).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/estoque/historico/relatorio.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<MovimentoEstoque[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao gerar relatório de estoque');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Lista todos os produtos disponíveis para gestão de estoque em um contrato
   */
  async getProdutosEstoqueContrato(id_contrato: number) {
    try {
      if (!id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      const response = await api.get<ApiResponse<ProdutoEstoqueContrato[]>>(
        `/contratos/estoque/produtos.php?id_contrato=${id_contrato}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar produtos do contrato');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Adiciona estoque a um produto através de um contrato específico
   */
  async adicionarEstoqueViaContrato(data: AdicionarEstoqueContratoData) {
    try {
      console.log('API Service - Dados recebidos:', data);

      // Validações básicas
      if (!data.id_contrato || !data.id_produto || !data.quantidade || !data.motivo) {
        throw new Error('ID do contrato, ID do produto, quantidade e motivo são obrigatórios');
      }

      if (data.quantidade <= 0) {
        throw new Error('Quantidade deve ser maior que zero');
      }

      if (data.custo_unitario !== undefined && data.custo_unitario < 0) {
        throw new Error('Custo unitário deve ser maior ou igual a zero');
      }

      console.log('API Service - Enviando para o backend:', data);

      const response = await api.post<ApiResponse<AdicionarEstoqueResponse>>(
        '/contratos/estoque/adicionar.php',
        data
      );

      console.log('API Service - Resposta do backend:', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao adicionar estoque via contrato');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao adicionar estoque via contrato:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Adiciona múltiplos produtos ao estoque através de um contrato
   */
  async adicionarMultiplosEstoqueViaContrato(data: AdicionarMultiplosEstoqueContratoData) {
    try {
      console.log('API Service - Dados recebidos para adição múltipla:', data);

      // Validações básicas
      if (!data.id_contrato) {
        throw new Error('ID do contrato é obrigatório');
      }

      if (!data.motivo) {
        throw new Error('Motivo é obrigatório');
      }

      if (!data.itens || data.itens.length === 0) {
        throw new Error('Adicione pelo menos um produto');
      }

      // Validar cada item
      for (const item of data.itens) {
        if (!item.id_produto) {
          throw new Error('ID do produto é obrigatório em todos os itens');
        }
        if (!item.quantidade || item.quantidade <= 0) {
          throw new Error('Quantidade deve ser maior que zero em todos os itens');
        }
        if (!item.custo_unitario || item.custo_unitario < 0) {
          throw new Error('Custo unitário deve ser maior ou igual a zero em todos os itens');
        }
      }

      console.log('API Service - Enviando múltiplos itens para o backend:', data);

      const response = await api.post<AdicionarMultiplosEstoqueResponse>(
        '/contratos/estoque/adicionar-multiplos.php',
        data
      );

      console.log('API Service - Resposta do backend (múltiplos):', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao adicionar múltiplos produtos ao estoque');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado ao adicionar múltiplos produtos:', error);
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ADMINISTRAÇÃO - AÇÕES DO SISTEMA
  // ============================================================================

  /**
   * Lista todas as ações do sistema ou busca uma ação específica por ID
   */
  async getAcoesSistema(filters?: AcaoSistemaFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/admin/acoes/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<AcaoSistema[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar ações do sistema');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca uma ação específica por ID
   */
  async getAcaoSistemaById(id: number) {
    try {
      if (!id) {
        throw new Error('ID da ação é obrigatório');
      }

      const response = await api.get<ApiResponse<AcaoSistema>>(`/admin/acoes/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Ação não encontrada');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Cria uma nova ação do sistema
   */
  async createAcaoSistema(data: CreateAcaoSistemaData) {
    try {
      // Validações básicas
      if (!data.codigo || !data.nome) {
        throw new Error('Código e nome são obrigatórios');
      }

      const response = await api.post<ApiResponse<AcaoSistema>>('/admin/acoes/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar ação do sistema');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação da ação:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza uma ação do sistema existente
   */
  async updateAcaoSistema(id: number, data: UpdateAcaoSistemaData) {
    try {
      if (!id) {
        throw new Error('ID da ação é obrigatório');
      }

      const response = await api.put<ApiResponse<AcaoSistema>>(`/admin/acoes/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar ação do sistema');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização da ação:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Exclui uma ação do sistema (soft delete)
   */
  async deleteAcaoSistema(id: number) {
    try {
      if (!id) {
        throw new Error('ID da ação é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/admin/acoes/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir ação do sistema');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ADMINISTRAÇÃO - MÓDULOS DO SISTEMA
  // ============================================================================

  /**
   * Lista todos os módulos do sistema
   */
  async getModulosSistema(filters?: ModuloSistemaFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/admin/modulos/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<ModuloSistema[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar módulos do sistema');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca um módulo específico por ID
   */
  async getModuloSistemaById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do módulo é obrigatório');
      }

      const response = await api.get<ApiResponse<ModuloSistema>>(`/admin/modulos/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Módulo não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Cria um novo módulo do sistema
   */
  async createModuloSistema(data: CreateModuloSistemaData) {
    try {
      // Validações básicas
      if (!data.codigo || !data.nome) {
        throw new Error('Código e nome são obrigatórios');
      }

      const response = await api.post<ApiResponse<ModuloSistema>>('/admin/modulos/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar módulo do sistema');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do módulo:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza um módulo do sistema existente
   */
  async updateModuloSistema(id: number, data: UpdateModuloSistemaData) {
    try {
      if (!id) {
        throw new Error('ID do módulo é obrigatório');
      }

      const response = await api.put<ApiResponse<ModuloSistema>>(`/admin/modulos/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar módulo do sistema');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do módulo:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Exclui um módulo do sistema (soft delete)
   */
  async deleteModuloSistema(id: number) {
    try {
      if (!id) {
        throw new Error('ID do módulo é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/admin/modulos/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir módulo do sistema');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Alterna o status ativo/inativo de um módulo
   */
  async toggleModuloSistema(id: number) {
    try {
      if (!id) {
        throw new Error('ID do módulo é obrigatório');
      }

      const response = await api.patch<ApiResponse<{ ativo: boolean }>>(`/admin/modulos/toggle.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao alterar status do módulo');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ADMINISTRAÇÃO - PERFIS DE PERMISSÃO
  // ============================================================================

  /**
   * Lista todos os perfis de permissão (com contagem de usuários)
   */
  async getPerfisPermissao(filters?: PerfilPermissaoFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/admin/perfis/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<PerfilPermissao[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar perfis de permissão');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca um perfil específico por ID
   */
  async getPerfilPermissaoById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do perfil é obrigatório');
      }

      const response = await api.get<ApiResponse<PerfilPermissao>>(`/admin/perfis/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Perfil não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Cria um novo perfil de permissão
   */
  async createPerfilPermissao(data: CreatePerfilPermissaoData) {
    try {
      // Validações básicas
      if (!data.id_conta || !data.codigo || !data.nome) {
        throw new Error('ID da conta, código e nome são obrigatórios');
      }

      // Validação de formato de cor
      if (data.cor && !/^#[0-9A-F]{6}$/i.test(data.cor)) {
        throw new Error('Cor deve estar no formato hexadecimal (#RRGGBB)');
      }

      const response = await api.post<ApiResponse<PerfilPermissao>>('/admin/perfis/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar perfil de permissão');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do perfil:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza um perfil de permissão existente
   */
  async updatePerfilPermissao(id: number, data: UpdatePerfilPermissaoData) {
    try {
      if (!id) {
        throw new Error('ID do perfil é obrigatório');
      }

      // Validação de formato de cor
      if (data.cor && !/^#[0-9A-F]{6}$/i.test(data.cor)) {
        throw new Error('Cor deve estar no formato hexadecimal (#RRGGBB)');
      }

      const response = await api.put<ApiResponse<PerfilPermissao>>(`/admin/perfis/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar perfil de permissão');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do perfil:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Exclui um perfil de permissão
   */
  async deletePerfilPermissao(id: number) {
    try {
      if (!id) {
        throw new Error('ID do perfil é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/admin/perfis/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir perfil de permissão');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Duplica um perfil de permissão (copia todas as permissões)
   */
  async duplicatePerfilPermissao(id: number, data: DuplicatePerfilData) {
    try {
      if (!id) {
        throw new Error('ID do perfil original é obrigatório');
      }

      // Validações básicas
      if (!data.codigo || !data.nome) {
        throw new Error('Código e nome são obrigatórios');
      }

      // Validação de formato de cor
      if (data.cor && !/^#[0-9A-F]{6}$/i.test(data.cor)) {
        throw new Error('Cor deve estar no formato hexadecimal (#RRGGBB)');
      }

      const response = await api.post<ApiResponse<PerfilPermissao>>(`/admin/perfis/duplicate.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao duplicar perfil de permissão');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na duplicação do perfil:', error);
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ADMINISTRAÇÃO - PERMISSÕES DE PERFIL
  // ============================================================================

  /**
   * Lista permissões de um perfil específico
   */
  async getPermissoesPerfil(filters: PermissaoPerfilFilters) {
    try {
      if (!filters.id_perfil) {
        throw new Error('ID do perfil é obrigatório');
      }

      let queryParams = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const url = `/admin/perfis/permissoes/read.php?${queryParams.toString()}`;
      const response = await api.get<ApiResponse<PermissaoPerfil[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar permissões do perfil');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca uma permissão específica por ID
   */
  async getPermissaoPerfilById(id: number, id_perfil: number) {
    try {
      if (!id || !id_perfil) {
        throw new Error('ID da permissão e ID do perfil são obrigatórios');
      }

      const response = await api.get<ApiResponse<PermissaoPerfil>>(`/admin/perfis/permissoes/read.php?id=${id}&id_perfil=${id_perfil}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Permissão não encontrada');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Cria uma nova permissão para um perfil
   */
  async createPermissaoPerfil(data: CreatePermissaoPerfilData) {
    try {
      // Validações básicas
      if (!data.id_perfil || !data.id_modulo || !data.id_acao) {
        throw new Error('ID do perfil, ID do módulo e ID da ação são obrigatórios');
      }

      const response = await api.post<ApiResponse<PermissaoPerfil>>('/admin/perfis/permissoes/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar permissão do perfil');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação da permissão:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza uma permissão de perfil existente
   */
  async updatePermissaoPerfil(id: number, data: UpdatePermissaoPerfilData) {
    try {
      if (!id) {
        throw new Error('ID da permissão é obrigatório');
      }

      const response = await api.put<ApiResponse<PermissaoPerfil>>(`/admin/perfis/permissoes/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar permissão do perfil');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização da permissão:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Exclui uma permissão de perfil
   */
  async deletePermissaoPerfil(id: number) {
    try {
      if (!id) {
        throw new Error('ID da permissão é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/admin/perfis/permissoes/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir permissão do perfil');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza múltiplas permissões de um perfil de uma vez
   */
  async updateBulkPermissoesPerfil(data: BulkPermissoesData) {
    try {
      // Validações básicas
      if (!data.id_perfil || !data.permissoes || !Array.isArray(data.permissoes)) {
        throw new Error('ID do perfil e array de permissões são obrigatórios');
      }

      // Validação de cada permissão
      for (const permissao of data.permissoes) {
        if (permissao.id_modulo === undefined || permissao.id_modulo === null ||
          permissao.id_acao === undefined || permissao.id_acao === null ||
          typeof permissao.permitido !== 'boolean') {
          throw new Error('Cada permissão deve ter id_modulo, id_acao e permitido (boolean)');
        }
      }

      const response = await api.put<ApiResponse<null>>('/admin/perfis/permissoes/bulk.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar permissões do perfil');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização em lote das permissões:', error);
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ADMINISTRAÇÃO - RELATÓRIOS
  // ============================================================================

  /**
   * Matriz completa de permissões (módulos e ações)
   */
  async getRelatorioMatriz(filters?: RelatorioMatrizFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/admin/relatorios/matriz.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<RelatorioMatriz>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar matriz de permissões');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Relatório de usuários por perfil
   */
  async getRelatorioUsuariosPorPerfil(filters?: RelatorioUsuariosPerfilFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/admin/relatorios/usuarios-por-perfil.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<RelatorioUsuariosPorPerfil[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar relatório de usuários por perfil');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Lista usuários sem perfil atribuído
   */
  async getUsuariosSemPerfil() {
    try {
      const response = await api.get<ApiResponse<UsuarioSemPerfil[]>>('/admin/relatorios/usuarios-sem-perfil.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar usuários sem perfil');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar todos os usuários do sistema (sem filtros)
  async getUsuarios() {
    try {
      const response = await api.get<ApiResponse<Usuario[]>>('/admin/usuarios/list.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar usuários');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ADMINISTRAÇÃO - GESTÃO DE PERFIL DE USUÁRIOS
  // ============================================================================

  /**
   * Busca informações do perfil de um usuário
   */
  async getPerfilUsuario(id_usuario: number) {
    try {
      if (!id_usuario) {
        throw new Error('ID do usuário é obrigatório');
      }

      const response = await api.get<ApiResponse<PerfilUsuario>>(`/admin/usuarios/perfil/read.php?id_usuario=${id_usuario}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar perfil do usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza o perfil base de um usuário
   */
  async updatePerfilUsuario(data: UpdateUsuarioPerfilData) {
    try {
      // Validações básicas
      if (!data.id_usuario || !data.id_perfil) {
        throw new Error('ID do usuário e ID do perfil são obrigatórios');
      }

      const response = await api.put<ApiResponse<PerfilUsuario>>('/admin/usuarios/perfil/update.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar perfil do usuário');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do perfil do usuário:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Remove o perfil base de um usuário (id_perfil_base = NULL)
   */
  async deletePerfilUsuario(id_usuario: number) {
    try {
      if (!id_usuario) {
        throw new Error('ID do usuário é obrigatório');
      }

      const response = await api.delete<ApiResponse<PerfilUsuario>>(`/admin/usuarios/perfil/delete.php?id_usuario=${id_usuario}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao remover perfil do usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============================================================================
  // MÓDULO DE ADMINISTRAÇÃO - PERMISSÕES DE USUÁRIOS (EXCEÇÕES)
  // ============================================================================

  /**
   * Lista exceções de permissão de um usuário específico
   */
  async getPermissoesUsuario(filters: PermissaoUsuarioFilters) {
    try {
      let queryParams = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const url = `/admin/usuarios/permissoes/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<PermissaoUsuario[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar permissões do usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca uma exceção específica por ID
   */
  async getPermissaoUsuarioById(id: number) {
    try {
      if (!id) {
        throw new Error('ID da permissão é obrigatório');
      }

      const response = await api.get<ApiResponse<PermissaoUsuario>>(`/admin/usuarios/permissoes/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Permissão não encontrada');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Cria uma nova exceção de permissão para um usuário
   */
  async createPermissaoUsuario(data: CreatePermissaoUsuarioData) {
    try {
      // Validações básicas
      if (!data.id_usuario || !data.id_modulo || !data.id_acao || !data.tipo_permissao) {
        throw new Error('ID do usuário, ID do módulo, ID da ação e tipo de permissão são obrigatórios');
      }

      // Validação do tipo de permissão
      if (!['ADICIONAR', 'REMOVER'].includes(data.tipo_permissao)) {
        throw new Error('Tipo de permissão deve ser "ADICIONAR" ou "REMOVER"');
      }

      // Validação do campo permitido
      if (typeof data.permitido !== 'boolean') {
        throw new Error('Campo "permitido" deve ser um valor booleano');
      }

      const response = await api.post<ApiResponse<PermissaoUsuario>>('/admin/usuarios/permissoes/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar permissão do usuário');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação da permissão do usuário:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Atualiza uma exceção de permissão de usuário existente
   */
  async updatePermissaoUsuario(id: number, data: UpdatePermissaoUsuarioData) {
    try {
      if (!id) {
        throw new Error('ID da permissão é obrigatório');
      }

      // Validação do tipo de permissão (se fornecido)
      if (data.tipo_permissao && !['ADICIONAR', 'REMOVER'].includes(data.tipo_permissao)) {
        throw new Error('Tipo de permissão deve ser "ADICIONAR" ou "REMOVER"');
      }

      // Validação do campo permitido (se fornecido)
      if (data.permitido !== undefined && typeof data.permitido !== 'boolean') {
        throw new Error('Campo "permitido" deve ser um valor booleano');
      }

      const response = await api.put<ApiResponse<PermissaoUsuario>>(`/admin/usuarios/permissoes/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar permissão do usuário');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização da permissão do usuário:', error);
      throw this.handleError(error);
    }
  },

  /**
   * Exclui uma exceção de permissão de usuário
   */
  async deletePermissaoUsuario(id: number) {
    try {
      if (!id) {
        throw new Error('ID da permissão é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/admin/usuarios/permissoes/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir permissão do usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ============== MÉTODOS DE GERENCIAMENTO DE USUÁRIOS ==============

  // Buscar usuários com filtros específicos
  async searchUsuarios(filters?: UsuarioFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/admin/usuarios/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<ApiResponse<Usuario[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar usuários');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar usuário específico por ID
  async getUsuarioById(id: number) {
    try {
      if (!id) {
        throw new Error('ID do usuário é obrigatório');
      }

      const response = await api.get<ApiResponse<Usuario>>(`/admin/usuarios/read.php?id=${id}`);

      if (!response.data.success || !response.data.data) {
        throw new Error('Usuário não encontrado');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar novo usuário
  async createUsuario(data: CreateUsuarioData) {
    try {
      // Validações básicas
      if (!data.nome || !data.email || !data.senha) {
        throw new Error('Nome, email e senha são obrigatórios');
      }

      // Validação de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.email)) {
        throw new Error('Email inválido');
      }

      // Validação de CPF (se fornecido)
      if (data.cpf && data.cpf.replace(/\D/g, '').length !== 11) {
        throw new Error('CPF deve conter 11 dígitos');
      }

      // Validação da senha
      if (data.senha.length < 6) {
        throw new Error('A senha deve ter no mínimo 6 caracteres');
      }

      const response = await api.post<ApiResponse<Usuario>>('/admin/usuarios/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar usuário existente
  async updateUsuario(id: number, data: UpdateUsuarioData) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do usuário é obrigatório');
      }

      // Validação de email (se fornecido)
      if (data.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(data.email)) {
          throw new Error('Email inválido');
        }
      }

      // Validação de CPF (se fornecido)
      if (data.cpf && data.cpf.replace(/\D/g, '').length !== 11) {
        throw new Error('CPF deve conter 11 dígitos');
      }

      // Validação da senha (se fornecida)
      if (data.senha && data.senha.length < 6) {
        throw new Error('A senha deve ter no mínimo 6 caracteres');
      }

      const response = await api.put<ApiResponse<Usuario>>(`/admin/usuarios/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Deletar usuário (soft delete)
  async deleteUsuario(id: number) {
    try {
      // Validação do ID
      if (!id) {
        throw new Error('ID do usuário é obrigatório');
      }

      const response = await api.delete<ApiResponse<null>>(`/admin/usuarios/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao deletar usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Reativar usuário
  async reativarUsuario(data: ReativarUsuarioData) {
    try {
      // Validação dos dados
      if (!data.id || data.acao !== 'reativar') {
        throw new Error('ID do usuário e ação de reativação são obrigatórios');
      }

      const response = await api.post<ApiResponse<Usuario>>('/admin/usuarios/delete.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao reativar usuário');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar permissões atualizadas
  async refreshPermissions() {
    try {
      const response = await api.get<ApiResponse<{
        permissoes: { [module: string]: string[] }
      }>>('/auth/permissions.php');

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar permissões');
      }

      return response.data.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ===== FORMAS DE PAGAMENTO =====

  // Listar formas de pagamento
  async getFormasPagamento(filters?: FormaPagamentoFilters) {
    try {
      let queryParams = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString());
          }
        });
      }

      const url = `/financeiro/formas_pagamento/read.php${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await api.get<FinanceiroApiResponse<FormaPagamento[]>>(url);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar formas de pagamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Criar nova forma de pagamento
  async createFormaPagamento(data: CreateFormaPagamentoData) {
    try {
      if (!data.nome) {
        throw new Error('Nome da forma de pagamento é obrigatório');
      }

      const response = await api.post<FinanceiroApiResponse<FormaPagamento>>('/financeiro/formas_pagamento/create.php', data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar forma de pagamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar forma de pagamento
  async updateFormaPagamento(id: number, data: UpdateFormaPagamentoData) {
    try {
      if (!id) {
        throw new Error('ID da forma de pagamento é obrigatório');
      }

      const response = await api.put<FinanceiroApiResponse<FormaPagamento>>(`/financeiro/formas_pagamento/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar forma de pagamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Excluir forma de pagamento
  async deleteFormaPagamento(id: number) {
    try {
      if (!id) {
        throw new Error('ID da forma de pagamento é obrigatório');
      }

      const response = await api.delete<FinanceiroApiResponse<null>>(`/financeiro/formas_pagamento/delete.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir forma de pagamento');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Definir forma de pagamento como padrão
  async setFormaPagamentoPadrao(id: number) {
    try {
      if (!id) {
        throw new Error('ID da forma de pagamento é obrigatório');
      }

      const response = await api.post<FinanceiroApiResponse<null>>(`/financeiro/formas_pagamento/set_padrao.php?id=${id}`);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao definir forma de pagamento como padrão');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // ===== ANEXOS HISTÓRICO ESTOQUE =====

  // Criar anexo de histórico de estoque
  async createAnexoHistoricoEstoque(data: CreateAnexoHistoricoEstoqueData) {
    try {
      if (!data.id_historico_estoque || !data.titulo || !data.arquivo) {
        throw new Error('ID do histórico, título e arquivo são obrigatórios');
      }

      const formData = new FormData();
      formData.append('id_historico_estoque', data.id_historico_estoque.toString());
      formData.append('titulo', data.titulo);

      if (data.descricao) {
        formData.append('descricao', data.descricao);
      }

      formData.append('arquivo', data.arquivo);

      const response = await api.post<FinanceiroApiResponse<{
        id: number;
        data: AnexoHistoricoEstoque;
      }>>('/estoque/historico/anexos/create.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao criar anexo do histórico de estoque');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na criação do anexo de histórico de estoque:', error);
      throw this.handleError(error);
    }
  },

  // Listar anexos de um histórico de estoque
  async getAnexosHistoricoEstoque(filters: AnexoHistoricoEstoqueFilters) {
    try {
      if (!filters.id_historico_estoque) {
        throw new Error('ID do histórico de estoque é obrigatório');
      }

      const queryParams = new URLSearchParams({
        id_historico_estoque: filters.id_historico_estoque.toString(),
        ...(filters.page && { page: filters.page.toString() }),
        ...(filters.per_page && { per_page: filters.per_page.toString() }),
        ...(filters.search && { search: filters.search }),
        ...(filters.tipo_arquivo && { tipo_arquivo: filters.tipo_arquivo }),
      });

      const response = await api.get<FinanceiroApiResponse<AnexoHistoricoEstoque[]>>(
        `/estoque/historico/anexos/read.php?${queryParams.toString()}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar anexos do histórico de estoque');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Atualizar anexo de histórico de estoque
  async updateAnexoHistoricoEstoque(id: number, data: UpdateAnexoHistoricoEstoqueData) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const response = await api.put<FinanceiroApiResponse<{
        data: AnexoHistoricoEstoque;
      }>>(`/estoque/historico/anexos/update.php?id=${id}`, data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao atualizar anexo do histórico de estoque');
      }

      return response.data;
    } catch (error) {
      console.error('Erro detalhado na atualização do anexo de histórico de estoque:', error);
      throw this.handleError(error);
    }
  },

  // Excluir anexo de histórico de estoque
  async deleteAnexoHistoricoEstoque(id: number) {
    try {
      if (!id) {
        throw new Error('ID do anexo é obrigatório');
      }

      const response = await api.delete<FinanceiroApiResponse<null>>(
        `/estoque/historico/anexos/delete.php?id=${id}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao excluir anexo do histórico de estoque');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Download de anexo de histórico de estoque
  async downloadAnexoHistoricoEstoque(id: number, nomeArquivo: string) {
    try {
      if (!id || !nomeArquivo) {
        throw new Error('ID do anexo e nome do arquivo são obrigatórios');
      }

      const response = await api.get(
        `/estoque/historico/anexos/download.php?id=${id}`,
        {
          responseType: 'blob',
        }
      );

      // Criar URL do blob e iniciar download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Buscar estatísticas de anexos de histórico de estoque
  async getEstatisticasAnexosHistoricoEstoque(idHistoricoEstoque: number) {
    try {
      if (!idHistoricoEstoque) {
        throw new Error('ID do histórico de estoque é obrigatório');
      }

      const response = await api.get<FinanceiroApiResponse<EstatisticasAnexosHistoricoEstoque>>(
        `/estoque/historico/anexos/estatisticas.php?id_historico_estoque=${idHistoricoEstoque}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao buscar estatísticas dos anexos');
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // --- Dashboard Analytics ---

  /**
   * Busca dados de Faturamento
   */
  async getDashboardFaturamento(params: DashboardFaturamentoParams): Promise<DashboardFaturamentoResponse> {
    try {
      const response = await api.get('/dashboard/analytics/faturamento.php', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca dados de Disputas e Contratos
   */
  async getDashboardDisputasContratos(params: DashboardDisputasParams): Promise<DashboardDisputasResponse> {
    try {
      const response = await api.get('/dashboard/analytics/disputas-contratos.php', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca dados de Contratos Ativos
   */
  async getDashboardContratosAtivos(params?: DashboardContratosAtivosParams): Promise<DashboardContratosAtivosResponse> {
    try {
      const response = await api.get('/dashboard/analytics/contratos-ativos.php', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Busca dados de Fluxo de Caixa
   */
  async getDashboardFluxoCaixa(params?: DashboardFluxoCaixaParams): Promise<DashboardFluxoCaixaResponse> {
    try {
      const response = await api.get('/dashboard/analytics/fluxo-caixa.php', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Gestão de Objetivos - Listar
   */
  async getDashboardObjetivos(params?: DashboardObjetivoFilters): Promise<DashboardObjetivosResponse> {
    try {
      const response = await api.get('/dashboard/analytics/objetivos.php', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Gestão de Objetivos - Criar
   */
  async createDashboardObjetivo(data: CreateDashboardObjetivoData): Promise<any> {
    try {
      const response = await api.post('/dashboard/analytics/objetivos.php', data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Gestão de Objetivos - Atualizar
   */
  async updateDashboardObjetivo(id: number, data: UpdateDashboardObjetivoData): Promise<any> {
    try {
      // Nota: O endpoint pode variar, assumindo PUT com ID na URL ou query param
      // O README diz: PUT /api/v1/dashboard/analytics/objetivos/123
      // Ajustando para o padrão do axios e possível estrutura de URL do projeto (que parece ser .php)
      // Se for rewrite URL, seria /objetivos/123. Se for .php direto, talvez precise de parametro.
      // Vou seguir o padrão de URLs .php visto acima: /dashboard/analytics/objetivos.php?id=...
      // Mas o README dizia RESTful URLs. O código existente usa .php.
      // Vou assumir RESTful com .php se o server suportar, ou query param.
      // O README diz: api/v1/dashboard/analytics/faturamento.php
      // Então os arquivos existem. Para UPDATE e DELETE em arquivos PHP puros, geralmente se passa o ID como query param ou body, ou usa rota específica.
      // O README diz: PUT /api/v1/dashboard/analytics/objetivos/123
      // Vou usar: /dashboard/analytics/objetivos.php?id=${id}
      const response = await api.put(`/dashboard/analytics/objetivos.php?id=${id}`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  /**
   * Gestão de Objetivos - Excluir
   */
  async deleteDashboardObjetivo(id: number): Promise<any> {
    try {
      const response = await api.delete(`/dashboard/analytics/objetivos.php?id=${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // --- PARCELAS EMPENHO ---

  async createParcelasDoEmpenho(data: any) {
    try {
      const response = await api.post('/empenho/parcelas/create.php', data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async updateParcelasDoEmpenho(id: number, data: any) {
    try {
      const response = await api.put(`/empenho/parcelas/update.php?id=${id}`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async cancelarParcelasDoEmpenho(idEmpenho: number) {
    try {
      const response = await api.put('/empenho/parcelas/cancelar.php', { id_empenho: idEmpenho });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async voltarParcelasParaPendente(idEmpenho: number) {
    try {
      const response = await api.put('/empenho/parcelas/voltar_pendente.php', { id_empenho: idEmpenho });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async validarParcelasDoEmpenho(idEmpenho: number) {
    try {
      const response = await api.get(`/empenho/parcelas/validar.php?id_empenho=${idEmpenho}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // --- ENTREGAS EMPENHO (ENTREGA PARCIAL) ---

  async getEntregasSaldo(idEmpenho: number) {
    try {
      const response = await api.get(`/empenho/entregas/saldo.php?id_empenho=${idEmpenho}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getEntregaPendente(idEmpenho: number) {
    try {
      const response = await api.get(`/empenho/entregas/pendente.php?id_empenho=${idEmpenho}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getEntregasHistorico(idEmpenho: number) {
    try {
      const response = await api.get(`/empenho/entregas/read.php?id_empenho=${idEmpenho}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Tratamento de erros padronizado
  handleError(error: any): Error {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // Erro com resposta do servidor
        const message = error.response.data?.message || 'Erro no servidor';
        return new Error(message);
      } else if (error.request) {
        // Erro sem resposta do servidor
        return new Error('Não foi possível conectar ao servidor');
      }
    }
    // Erro genérico
    return new Error('Ocorreu um erro inesperado');
  }
};